var items = {
  "block.minecraft.acacia_button": "Akacijos mygtukas",
  "block.minecraft.acacia_door": "Akacijos durys",
  "block.minecraft.acacia_fence": "Akacijos tvora",
  "block.minecraft.acacia_fence_gate": "Akacijos varteliai",
  "block.minecraft.acacia_hanging_sign": "Akacijos kabantis ženklas",
  "block.minecraft.acacia_leaves": "Akacijos lapai",
  "block.minecraft.acacia_log": "Akacijos rąstas",
  "block.minecraft.acacia_planks": "Akacijos lentos",
  "block.minecraft.acacia_pressure_plate": "Akacijos slėgio plokštė",
  "block.minecraft.acacia_sapling": "Akacijos sodinukas",
  "block.minecraft.acacia_shelf": "Akacijos lentyna",
  "block.minecraft.acacia_sign": "Akacijos ženklas",
  "block.minecraft.acacia_slab": "Akacijos pusblokis",
  "block.minecraft.acacia_stairs": "Akacijos laiptai",
  "block.minecraft.acacia_trapdoor": "Akacijos liukas",
  "block.minecraft.acacia_wall_hanging_sign": "Akacijos sienos kabantis ženklas",
  "block.minecraft.acacia_wall_sign": "Akacijos sienos ženklas",
  "block.minecraft.acacia_wood": "Akacijos medis",
  "block.minecraft.activator_rail": "Aktyvuojantieji bėgiai",
  "block.minecraft.air": "Oras",
  "block.minecraft.allium": "Česnakas",
  "block.minecraft.amethyst_block": "Ametisto blokas",
  "block.minecraft.amethyst_cluster": "Užaugęs ametisto kristalas",
  "block.minecraft.ancient_debris": "Senovinis fragmentas",
  "block.minecraft.andesite": "Andezitas",
  "block.minecraft.andesite_slab": "Andezito pusblokis",
  "block.minecraft.andesite_stairs": "Andezito laiptai",
  "block.minecraft.andesite_wall": "Andezito siena",
  "block.minecraft.anvil": "Priekalas",
  "block.minecraft.attached_melon_stem": "Prijungtas arbūzo stiebas",
  "block.minecraft.attached_pumpkin_stem": "Prijungtas moliūgo stiebas",
  "block.minecraft.azalea": "Azalija",
  "block.minecraft.azalea_leaves": "Azalijos lapai",
  "block.minecraft.azure_bluet": "Žydroji bajorė",
  "block.minecraft.bamboo": "Bambukas",
  "block.minecraft.bamboo_block": "Bambuko blokas",
  "block.minecraft.bamboo_button": "Bambuko mygtukas",
  "block.minecraft.bamboo_door": "Bambuko durys",
  "block.minecraft.bamboo_fence": "Bambuko tvora",
  "block.minecraft.bamboo_fence_gate": "Bambuko vartai",
  "block.minecraft.bamboo_hanging_sign": "Bambuko kabantis ženklas",
  "block.minecraft.bamboo_mosaic": "Bambuko mozaika",
  "block.minecraft.bamboo_mosaic_slab": "Bambuko mozaikos pusblokis",
  "block.minecraft.bamboo_mosaic_stairs": "Bambuko mozaikos laiptai",
  "block.minecraft.bamboo_planks": "Bambuko lentos",
  "block.minecraft.bamboo_pressure_plate": "Bambuko slėgio plokštė",
  "block.minecraft.bamboo_sapling": "Bambuko stiebas",
  "block.minecraft.bamboo_shelf": "Bambuko lentyna",
  "block.minecraft.bamboo_sign": "Bambuko ženklas",
  "block.minecraft.bamboo_slab": "Bambuko pusblokis",
  "block.minecraft.bamboo_stairs": "Bambuko laiptai",
  "block.minecraft.bamboo_trapdoor": "Bambuko liukas",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuko sienos kabantis ženklas",
  "block.minecraft.bamboo_wall_sign": "Bambuko sienos ženklas",
  "block.minecraft.banner.base.black": "Juodas paviršius",
  "block.minecraft.banner.base.blue": "Mėlynas paviršius",
  "block.minecraft.banner.base.brown": "Rudas paviršius",
  "block.minecraft.banner.base.cyan": "Turkio paviršius",
  "block.minecraft.banner.base.gray": "Pilkas paviršius",
  "block.minecraft.banner.base.green": "Žalias paviršius",
  "block.minecraft.banner.base.light_blue": "Žydras paviršius",
  "block.minecraft.banner.base.light_gray": "Šviesiai pilkas paviršius",
  "block.minecraft.banner.base.lime": "Šviesiai žalias paviršius",
  "block.minecraft.banner.base.magenta": "Purpurinis paviršius",
  "block.minecraft.banner.base.orange": "Oranžinis paviršius",
  "block.minecraft.banner.base.pink": "Rausvas paviršius",
  "block.minecraft.banner.base.purple": "Violetinis paviršius",
  "block.minecraft.banner.base.red": "Raudonas paviršius",
  "block.minecraft.banner.base.white": "Baltas paviršius",
  "block.minecraft.banner.base.yellow": "Geltonas paviršius",
  "block.minecraft.banner.border.black": "Juoda kraštinė",
  "block.minecraft.banner.border.blue": "Mėlyna kraštinė",
  "block.minecraft.banner.border.brown": "Ruda kraštinė",
  "block.minecraft.banner.border.cyan": "Turkio kraštinė",
  "block.minecraft.banner.border.gray": "Pilka kraštinė",
  "block.minecraft.banner.border.green": "Žalia kraštinė",
  "block.minecraft.banner.border.light_blue": "Žydra kraštinė",
  "block.minecraft.banner.border.light_gray": "Šviesiai pilka kraštinė",
  "block.minecraft.banner.border.lime": "Šviesiai žalia kraštinė",
  "block.minecraft.banner.border.magenta": "Purpurinė kraštinė",
  "block.minecraft.banner.border.orange": "Oranžinė kraštinė",
  "block.minecraft.banner.border.pink": "Rausva kraštinė",
  "block.minecraft.banner.border.purple": "Violetinė kraštinė",
  "block.minecraft.banner.border.red": "Raudona kraštinė",
  "block.minecraft.banner.border.white": "Balta kraštinė",
  "block.minecraft.banner.border.yellow": "Geltona kraštinė",
  "block.minecraft.banner.bricks.black": "Juodos plytos",
  "block.minecraft.banner.bricks.blue": "Mėlynos plytos",
  "block.minecraft.banner.bricks.brown": "Rudos plytos",
  "block.minecraft.banner.bricks.cyan": "Turkio plytos",
  "block.minecraft.banner.bricks.gray": "Pilkos plytos",
  "block.minecraft.banner.bricks.green": "Žalios plytos",
  "block.minecraft.banner.bricks.light_blue": "Žydros plytos",
  "block.minecraft.banner.bricks.light_gray": "Šviesiai pilkos plytos",
  "block.minecraft.banner.bricks.lime": "Šviesiai žalios plytos",
  "block.minecraft.banner.bricks.magenta": "Purpurinės plytos",
  "block.minecraft.banner.bricks.orange": "Oranžinės plytos",
  "block.minecraft.banner.bricks.pink": "Rausvos plytos",
  "block.minecraft.banner.bricks.purple": "Violetinės plytos",
  "block.minecraft.banner.bricks.red": "Raudonos plytos",
  "block.minecraft.banner.bricks.white": "Baltos plytos",
  "block.minecraft.banner.bricks.yellow": "Geltonos plytos",
  "block.minecraft.banner.circle.black": "Juodas apskritimas",
  "block.minecraft.banner.circle.blue": "Mėlynas apskritimas",
  "block.minecraft.banner.circle.brown": "Rudas apskritimas",
  "block.minecraft.banner.circle.cyan": "Turkio apskritimas",
  "block.minecraft.banner.circle.gray": "Pilkas apskritimas",
  "block.minecraft.banner.circle.green": "Žalias apskritimas",
  "block.minecraft.banner.circle.light_blue": "Žydras apskritimas",
  "block.minecraft.banner.circle.light_gray": "Šviesiai pilkas apskritimas",
  "block.minecraft.banner.circle.lime": "Šviesiai žalias apskritimas",
  "block.minecraft.banner.circle.magenta": "Purpurinis apskritimas",
  "block.minecraft.banner.circle.orange": "Oranžinis apskritimas",
  "block.minecraft.banner.circle.pink": "Rausvas apskritimas",
  "block.minecraft.banner.circle.purple": "Violetinis apskritimas",
  "block.minecraft.banner.circle.red": "Raudonas apskritimas",
  "block.minecraft.banner.circle.white": "Baltas apskritimas",
  "block.minecraft.banner.circle.yellow": "Geltonas apskritimas",
  "block.minecraft.banner.creeper.black": "Juodas kryperis",
  "block.minecraft.banner.creeper.blue": "Mėlynas kryperis",
  "block.minecraft.banner.creeper.brown": "Rudas kryperis",
  "block.minecraft.banner.creeper.cyan": "Turkio kryperis",
  "block.minecraft.banner.creeper.gray": "Pilkas kryperis",
  "block.minecraft.banner.creeper.green": "Žalias kryperis",
  "block.minecraft.banner.creeper.light_blue": "Žydras kryperis",
  "block.minecraft.banner.creeper.light_gray": "Šviesiai pilkas kryperis",
  "block.minecraft.banner.creeper.lime": "Šviesiai žalias kryperis",
  "block.minecraft.banner.creeper.magenta": "Purpurinis kryperis",
  "block.minecraft.banner.creeper.orange": "Oranžinis kryperis",
  "block.minecraft.banner.creeper.pink": "Rausvas kryperis",
  "block.minecraft.banner.creeper.purple": "Violetinis kryperis",
  "block.minecraft.banner.creeper.red": "Raudonas kryperis",
  "block.minecraft.banner.creeper.white": "Baltas kryperis",
  "block.minecraft.banner.creeper.yellow": "Geltonas kryperis",
  "block.minecraft.banner.cross.black": "Juodas įstrižas kryžius",
  "block.minecraft.banner.cross.blue": "Mėlynas įstrižas kryžius",
  "block.minecraft.banner.cross.brown": "Rudas įstrižas kryžius",
  "block.minecraft.banner.cross.cyan": "Turkio įstrižas kryžius",
  "block.minecraft.banner.cross.gray": "Pilkas įstrižas kryžius",
  "block.minecraft.banner.cross.green": "Žalias įstrižas kryžius",
  "block.minecraft.banner.cross.light_blue": "Žydras įstrižas kryžius",
  "block.minecraft.banner.cross.light_gray": "Šviesiai pilkas įstrižas kryžius",
  "block.minecraft.banner.cross.lime": "Šviesiai žalias įstrižas kryžius",
  "block.minecraft.banner.cross.magenta": "Purpurinis įstrižas kryžius",
  "block.minecraft.banner.cross.orange": "Oranžinis įstrižas kryžius",
  "block.minecraft.banner.cross.pink": "Rausvas įstrižas kryžius",
  "block.minecraft.banner.cross.purple": "Violetinis įstrižas kryžius",
  "block.minecraft.banner.cross.red": "Raudonas įstrižas kryžius",
  "block.minecraft.banner.cross.white": "Baltas įstrižas kryžius",
  "block.minecraft.banner.cross.yellow": "Geltonas įstrižas kryžius",
  "block.minecraft.banner.curly_border.black": "Juoda vingiuota kraštinė",
  "block.minecraft.banner.curly_border.blue": "Mėlyna vingiuota kraštinė",
  "block.minecraft.banner.curly_border.brown": "Ruda vingiuota kraštinė",
  "block.minecraft.banner.curly_border.cyan": "Turkio vingiuota kraštinė",
  "block.minecraft.banner.curly_border.gray": "Pilka vingiuota kraštinė",
  "block.minecraft.banner.curly_border.green": "Žalia vingiuota kraštinė",
  "block.minecraft.banner.curly_border.light_blue": "Žydra vingiuota kraštinė",
  "block.minecraft.banner.curly_border.light_gray": "Šviesiai pilka vingiuota kraštinė",
  "block.minecraft.banner.curly_border.lime": "Šviesiai žalia vingiuota kraštinė",
  "block.minecraft.banner.curly_border.magenta": "Purpurinė vingiuota kraštinė",
  "block.minecraft.banner.curly_border.orange": "Oranžinė vingiuota kraštinė",
  "block.minecraft.banner.curly_border.pink": "Rausva vingiuota kraštinė",
  "block.minecraft.banner.curly_border.purple": "Violetinė vingiuota kraštinė",
  "block.minecraft.banner.curly_border.red": "Raudona vingiuota kraštinė",
  "block.minecraft.banner.curly_border.white": "Balta vingiuota kraštinė",
  "block.minecraft.banner.curly_border.yellow": "Geltona vingiuota kraštinė",
  "block.minecraft.banner.diagonal_left.black": "Juoda įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.blue": "Mėlyna įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.brown": "Ruda įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.cyan": "Turkio įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.gray": "Pilka įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.green": "Žalia įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.light_blue": "Žydra įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.light_gray": "Šviesiai pilka įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.lime": "Šviesiai žalia įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.magenta": "Purpurinė įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.orange": "Oranžinė įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.pink": "Rausva įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.purple": "Violetinė įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.red": "Raudona įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.white": "Balta įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_left.yellow": "Geltona įstrižainė kairėje viršuje",
  "block.minecraft.banner.diagonal_right.black": "Juoda įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.blue": "Mėlyna įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.brown": "Ruda įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.cyan": "Turkio įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.gray": "Pilka įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.green": "Žalia įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.light_blue": "Šviesiai mėlyna įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.light_gray": "Šviesiai pilka įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.lime": "Šviesiai žalia įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.magenta": "Purpurinė įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.orange": "Oranžinė įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.pink": "Rausva įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.purple": "Violetinė įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.red": "Raudona įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.white": "Balta įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_right.yellow": "Geltona įstrižainė dešinėje viršuje",
  "block.minecraft.banner.diagonal_up_left.black": "Juoda įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.blue": "Mėlyna įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.brown": "Ruda įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turkio įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.gray": "Pilka įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.green": "Žalia įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Žydra įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Šviesiai pilka įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.lime": "Šviesiai žalia įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purpurinė įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranžinė įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.pink": "Rausva įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.purple": "Violetinė įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.red": "Raudona įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.white": "Balta įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_left.yellow": "Geltona įstrižainė kairėje apačioje",
  "block.minecraft.banner.diagonal_up_right.black": "Juoda įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.blue": "Mėlyna įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.brown": "Ruda įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turkio įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.gray": "Pilka įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.green": "Žalia įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Žydra įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Šviesiai pilka įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.lime": "Šviesiai žalia įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purpurinė įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranžinė įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.pink": "Rausva įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.purple": "Violetinė įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.red": "Raudona įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.white": "Balta įstrižainė dešinėje apačioje",
  "block.minecraft.banner.diagonal_up_right.yellow": "Geltona įstrižainė dešinėje apačioje",
  "block.minecraft.banner.flow.black": "Juoda spiralė",
  "block.minecraft.banner.flow.blue": "Mėlyna spiralė",
  "block.minecraft.banner.flow.brown": "Ruda spiralė",
  "block.minecraft.banner.flow.cyan": "Turkio spiralė",
  "block.minecraft.banner.flow.gray": "Pilka spiralė",
  "block.minecraft.banner.flow.green": "Žalia spiralė",
  "block.minecraft.banner.flow.light_blue": "Žydra spiralė",
  "block.minecraft.banner.flow.light_gray": "Šviesiai pilka spiralė",
  "block.minecraft.banner.flow.lime": "Šviesiai žalia spiralė",
  "block.minecraft.banner.flow.magenta": "Purpurinė spiralė",
  "block.minecraft.banner.flow.orange": "Oranžinė spiralė",
  "block.minecraft.banner.flow.pink": "Rausva spiralė",
  "block.minecraft.banner.flow.purple": "Violetinė spiralė",
  "block.minecraft.banner.flow.red": "Raudona spiralė",
  "block.minecraft.banner.flow.white": "Balta spiralė",
  "block.minecraft.banner.flow.yellow": "Geltona spiralė",
  "block.minecraft.banner.flower.black": "Juoda gėlė",
  "block.minecraft.banner.flower.blue": "Mėlyna gėlė",
  "block.minecraft.banner.flower.brown": "Ruda gėlė",
  "block.minecraft.banner.flower.cyan": "Turkio gėlė",
  "block.minecraft.banner.flower.gray": "Pilka gėlė",
  "block.minecraft.banner.flower.green": "Žalia gėlė",
  "block.minecraft.banner.flower.light_blue": "Žydra gėlė",
  "block.minecraft.banner.flower.light_gray": "Šviesiai pilka gėlė",
  "block.minecraft.banner.flower.lime": "Šviesiai žalia gėlė",
  "block.minecraft.banner.flower.magenta": "Purpurinė gėlė",
  "block.minecraft.banner.flower.orange": "Oranžinė gėlė",
  "block.minecraft.banner.flower.pink": "Rausva gėlė",
  "block.minecraft.banner.flower.purple": "Violetinė gėlė",
  "block.minecraft.banner.flower.red": "Raudona gėlė",
  "block.minecraft.banner.flower.white": "Balta gėlė",
  "block.minecraft.banner.flower.yellow": "Geltona gėlė",
  "block.minecraft.banner.globe.black": "Juodas gaublys",
  "block.minecraft.banner.globe.blue": "Mėlynas gaublys",
  "block.minecraft.banner.globe.brown": "Rudas gaublys",
  "block.minecraft.banner.globe.cyan": "Turkio gaublys",
  "block.minecraft.banner.globe.gray": "Pilkas gaublys",
  "block.minecraft.banner.globe.green": "Žalias gaublys",
  "block.minecraft.banner.globe.light_blue": "Žydras gaublys",
  "block.minecraft.banner.globe.light_gray": "Šviesiai pilkas gaublys",
  "block.minecraft.banner.globe.lime": "Šviesiai žalias gaublys",
  "block.minecraft.banner.globe.magenta": "Purpurinis gaublys",
  "block.minecraft.banner.globe.orange": "Oranžinis gaublys",
  "block.minecraft.banner.globe.pink": "Rausvas gaublys",
  "block.minecraft.banner.globe.purple": "Violetinis gaublys",
  "block.minecraft.banner.globe.red": "Raudonas gaublys",
  "block.minecraft.banner.globe.white": "Baltas gaublys",
  "block.minecraft.banner.globe.yellow": "Geltonas gaublys",
  "block.minecraft.banner.gradient.black": "Juodas gradientas viršuje",
  "block.minecraft.banner.gradient.blue": "Mėlynas gradientas viršuje",
  "block.minecraft.banner.gradient.brown": "Rudas gradientas viršuje",
  "block.minecraft.banner.gradient.cyan": "Turkio gradientas viršuje",
  "block.minecraft.banner.gradient.gray": "Pilkas gradientas viršuje",
  "block.minecraft.banner.gradient.green": "Žalias gradientas viršuje",
  "block.minecraft.banner.gradient.light_blue": "Žydras gradientas viršuje",
  "block.minecraft.banner.gradient.light_gray": "Šviesiai pilkas gradientas viršuje",
  "block.minecraft.banner.gradient.lime": "Šviesiai žalias gradientas viršuje",
  "block.minecraft.banner.gradient.magenta": "Purpurinis gradientas viršuje",
  "block.minecraft.banner.gradient.orange": "Oranžinis gradientas viršuje",
  "block.minecraft.banner.gradient.pink": "Rausvas gradientas viršuje",
  "block.minecraft.banner.gradient.purple": "Violetinis gradientas viršuje",
  "block.minecraft.banner.gradient.red": "Raudonas gradientas viršuje",
  "block.minecraft.banner.gradient.white": "Baltas gradientas viršuje",
  "block.minecraft.banner.gradient.yellow": "Geltonas gradientas viršuje",
  "block.minecraft.banner.gradient_up.black": "Juodas gradientas apačioje",
  "block.minecraft.banner.gradient_up.blue": "Mėlynas gradientas apačioje",
  "block.minecraft.banner.gradient_up.brown": "Rudas gradientas apačioje",
  "block.minecraft.banner.gradient_up.cyan": "Turkio gradientas apačioje",
  "block.minecraft.banner.gradient_up.gray": "Pilkas gradientas apačioje",
  "block.minecraft.banner.gradient_up.green": "Žalias gradientas apačioje",
  "block.minecraft.banner.gradient_up.light_blue": "Žydras gradientas apačioje",
  "block.minecraft.banner.gradient_up.light_gray": "Šviesiai pilkas gradientas apačioje",
  "block.minecraft.banner.gradient_up.lime": "Šviesiai žalias gradientas apačioje",
  "block.minecraft.banner.gradient_up.magenta": "Purpurinis gradientas apačioje",
  "block.minecraft.banner.gradient_up.orange": "Oranžinis gradientas apačioje",
  "block.minecraft.banner.gradient_up.pink": "Rausvas gradientas apačioje",
  "block.minecraft.banner.gradient_up.purple": "Violetinis gradientas apačioje",
  "block.minecraft.banner.gradient_up.red": "Raudonas gradientas apačioje",
  "block.minecraft.banner.gradient_up.white": "Baltas gradientas apačioje",
  "block.minecraft.banner.gradient_up.yellow": "Geltonas gradientas apačioje",
  "block.minecraft.banner.guster.black": "Juodas gūsis",
  "block.minecraft.banner.guster.blue": "Mėlynas gūsis",
  "block.minecraft.banner.guster.brown": "Rudas gūsis",
  "block.minecraft.banner.guster.cyan": "Turkio gūsis",
  "block.minecraft.banner.guster.gray": "Pilkas gūsis",
  "block.minecraft.banner.guster.green": "Žalias gūsis",
  "block.minecraft.banner.guster.light_blue": "Žydras gūsis",
  "block.minecraft.banner.guster.light_gray": "Šviesiai pilkas gūsis",
  "block.minecraft.banner.guster.lime": "Šviesiai žalias gūsis",
  "block.minecraft.banner.guster.magenta": "Šviesiai purpurinis gūsis",
  "block.minecraft.banner.guster.orange": "Oranžinis gūsis",
  "block.minecraft.banner.guster.pink": "Rausvas gūsis",
  "block.minecraft.banner.guster.purple": "Violetinis gūsis",
  "block.minecraft.banner.guster.red": "Raudonas gūsis",
  "block.minecraft.banner.guster.white": "Baltas gūsis",
  "block.minecraft.banner.guster.yellow": "Geltonas gūsis",
  "block.minecraft.banner.half_horizontal.black": "Juoda horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.blue": "Mėlyna horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.brown": "Ruda horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.cyan": "Turkio horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.gray": "Pilka horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.green": "Žalia horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.light_blue": "Žydra horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.light_gray": "Šviesiai pilka horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.lime": "Šviesiai žalia horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.magenta": "Purpurinė horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.orange": "Oranžinė horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.pink": "Rausva horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.purple": "Violetinė horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.red": "Raudona horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.white": "Balta horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal.yellow": "Geltona horizontali pusė viršuje",
  "block.minecraft.banner.half_horizontal_bottom.black": "Juoda horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Mėlyna horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Ruda horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turkio horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Pilka horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.green": "Žalia horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Žydra horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Šviesiai pilka horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Šviesiai žalia horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purpurinė horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranžinė horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rausva horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Violetinė horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.red": "Raudona horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.white": "Balta horizontali pusė apačioje",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Geltona horizontali pusė apačioje",
  "block.minecraft.banner.half_vertical.black": "Juoda vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.blue": "Mėlyna vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.brown": "Ruda vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.cyan": "Turkio vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.gray": "Pilka vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.green": "Žalia vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.light_blue": "Žydra vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.light_gray": "Šviesiai pilka vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.lime": "Šviesiai žalia vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.magenta": "Purpurinė vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.orange": "Oranžinė vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.pink": "Rausva vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.purple": "Violetinė vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.red": "Raudona vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.white": "Balta vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical.yellow": "Geltona vertikali pusė kairėje",
  "block.minecraft.banner.half_vertical_right.black": "Juoda vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.blue": "Mėlyna vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.brown": "Ruda vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.cyan": "Turkio vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.gray": "Pilka vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.green": "Žalia vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.light_blue": "Žydra vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.light_gray": "Šviesiai pilka vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.lime": "Šviesiai žalia vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.magenta": "Purpurinė vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.orange": "Oranžinė vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.pink": "Rausva vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.purple": "Violetinė vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.red": "Raudona vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.white": "Balta vertikali pusė dešinėje",
  "block.minecraft.banner.half_vertical_right.yellow": "Geltona vertikali pusė dešinėje",
  "block.minecraft.banner.mojang.black": "Juodas dalykas",
  "block.minecraft.banner.mojang.blue": "Mėlynas dalykas",
  "block.minecraft.banner.mojang.brown": "Rudas dalykas",
  "block.minecraft.banner.mojang.cyan": "Turkio dalykas",
  "block.minecraft.banner.mojang.gray": "Pilkas dalykas",
  "block.minecraft.banner.mojang.green": "Žalias dalykas",
  "block.minecraft.banner.mojang.light_blue": "Žydras dalykas",
  "block.minecraft.banner.mojang.light_gray": "Šviesiai pilkas dalykas",
  "block.minecraft.banner.mojang.lime": "Šviesiai žalias dalykas",
  "block.minecraft.banner.mojang.magenta": "Purpurinis dalykas",
  "block.minecraft.banner.mojang.orange": "Oranžinis dalykas",
  "block.minecraft.banner.mojang.pink": "Rausvas dalykas",
  "block.minecraft.banner.mojang.purple": "Violetinis dalykas",
  "block.minecraft.banner.mojang.red": "Raudonas dalykas",
  "block.minecraft.banner.mojang.white": "Baltas dalykas",
  "block.minecraft.banner.mojang.yellow": "Geltonas dalykas",
  "block.minecraft.banner.piglin.black": "Juodas šnipas",
  "block.minecraft.banner.piglin.blue": "Mėlynas šnipas",
  "block.minecraft.banner.piglin.brown": "Rudas šnipas",
  "block.minecraft.banner.piglin.cyan": "Turkio šnipas",
  "block.minecraft.banner.piglin.gray": "Pilkas šnipas",
  "block.minecraft.banner.piglin.green": "Žalias šnipas",
  "block.minecraft.banner.piglin.light_blue": "Žydras šnipas",
  "block.minecraft.banner.piglin.light_gray": "Šviesiai pilkas šnipas",
  "block.minecraft.banner.piglin.lime": "Šviesiai žalias šnipas",
  "block.minecraft.banner.piglin.magenta": "Purpurinis šnipas",
  "block.minecraft.banner.piglin.orange": "Oranžinis šnipas",
  "block.minecraft.banner.piglin.pink": "Rausvas šnipas",
  "block.minecraft.banner.piglin.purple": "Violetinis šnipas",
  "block.minecraft.banner.piglin.red": "Raudonas šnipas",
  "block.minecraft.banner.piglin.white": "Baltas šnipas",
  "block.minecraft.banner.piglin.yellow": "Geltonas šnipas",
  "block.minecraft.banner.rhombus.black": "Juodas rombas",
  "block.minecraft.banner.rhombus.blue": "Mėlynas rombas",
  "block.minecraft.banner.rhombus.brown": "Rudas rombas",
  "block.minecraft.banner.rhombus.cyan": "Turkio rombas",
  "block.minecraft.banner.rhombus.gray": "Pilkas rombas",
  "block.minecraft.banner.rhombus.green": "Žalias rombas",
  "block.minecraft.banner.rhombus.light_blue": "Žydras rombas",
  "block.minecraft.banner.rhombus.light_gray": "Šviesiai pilkas rombas",
  "block.minecraft.banner.rhombus.lime": "Šviesiai žalias rombas",
  "block.minecraft.banner.rhombus.magenta": "Purpurinis rombas",
  "block.minecraft.banner.rhombus.orange": "Oranžinis rombas",
  "block.minecraft.banner.rhombus.pink": "Rausvas rombas",
  "block.minecraft.banner.rhombus.purple": "Violetinis rombas",
  "block.minecraft.banner.rhombus.red": "Raudonas rombas",
  "block.minecraft.banner.rhombus.white": "Baltas rombas",
  "block.minecraft.banner.rhombus.yellow": "Geltonas rombas",
  "block.minecraft.banner.skull.black": "Juoda kaukolė",
  "block.minecraft.banner.skull.blue": "Mėlyna kaukolė",
  "block.minecraft.banner.skull.brown": "Ruda kaukolė",
  "block.minecraft.banner.skull.cyan": "Turkio kaukolė",
  "block.minecraft.banner.skull.gray": "Pilka kaukolė",
  "block.minecraft.banner.skull.green": "Žalia kaukolė",
  "block.minecraft.banner.skull.light_blue": "Žydra kaukolė",
  "block.minecraft.banner.skull.light_gray": "Šviesiai pilka kaukolė",
  "block.minecraft.banner.skull.lime": "Šviesiai žalia kaukolė",
  "block.minecraft.banner.skull.magenta": "Purpurinė kaukolė",
  "block.minecraft.banner.skull.orange": "Oranžinė kaukolė",
  "block.minecraft.banner.skull.pink": "Rausva kaukolė",
  "block.minecraft.banner.skull.purple": "Violetinė kaukolė",
  "block.minecraft.banner.skull.red": "Raudona kaukolė",
  "block.minecraft.banner.skull.white": "Balta kaukolė",
  "block.minecraft.banner.skull.yellow": "Geltona kaukolė",
  "block.minecraft.banner.small_stripes.black": "Juodos vertikalios juostelės",
  "block.minecraft.banner.small_stripes.blue": "Mėlynos vertikalios juostelės",
  "block.minecraft.banner.small_stripes.brown": "Rudos vertikalios juostelės",
  "block.minecraft.banner.small_stripes.cyan": "Turkio vertikalios juostelės",
  "block.minecraft.banner.small_stripes.gray": "Pilkos vertikalios juostelės",
  "block.minecraft.banner.small_stripes.green": "Žalios vertikalios juostelės",
  "block.minecraft.banner.small_stripes.light_blue": "Žydros vertikalios juostelės",
  "block.minecraft.banner.small_stripes.light_gray": "Šviesiai pilkos vertikalios juostelės",
  "block.minecraft.banner.small_stripes.lime": "Šviesiai žalios vertikalios juostelės",
  "block.minecraft.banner.small_stripes.magenta": "Purpurinės vertikalios juostelės",
  "block.minecraft.banner.small_stripes.orange": "Oranžinės vertikalios juostelės",
  "block.minecraft.banner.small_stripes.pink": "Rausvos vertikalios juostelės",
  "block.minecraft.banner.small_stripes.purple": "Violetinės vertikalios juostelės",
  "block.minecraft.banner.small_stripes.red": "Raudonos vertikalios juostelės",
  "block.minecraft.banner.small_stripes.white": "Baltos vertikalios juostelės",
  "block.minecraft.banner.small_stripes.yellow": "Geltonos vertikalios juostelės",
  "block.minecraft.banner.square_bottom_left.black": "Juodas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.blue": "Mėlynas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.brown": "Rudas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.cyan": "Turkio kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.gray": "Pilkas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.green": "Žalias kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.light_blue": "Žydras kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.light_gray": "Šviesiai pilkas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.lime": "Šviesiai žalias kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.magenta": "Purpurinis kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.orange": "Oranžinis kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.pink": "Rausvas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.purple": "Violetinis kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.red": "Raudonas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.white": "Baltas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_left.yellow": "Geltonas kampas kairėje apačioje",
  "block.minecraft.banner.square_bottom_right.black": "Juodas kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.blue": "Mėlynas kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.brown": "Rudas kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.cyan": "Turkio kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.gray": "Pilkas kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.green": "Žalias kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.light_blue": "Žydras kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.light_gray": "Šviesiai pilkas kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.lime": "Šviesiai žalias kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.magenta": "Purpurinis kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.orange": "Oranžinis kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.pink": "Rausvas kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.purple": "Violetinis kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.red": "Raudonas kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.white": "Baltas kampas dešinėje apačioje",
  "block.minecraft.banner.square_bottom_right.yellow": "Geltonas kampas dešinėje apačioje",
  "block.minecraft.banner.square_top_left.black": "Juodas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.blue": "Mėlynas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.brown": "Rudas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.cyan": "Turkio kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.gray": "Pilkas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.green": "Žalias kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.light_blue": "Žydras kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.light_gray": "Šviesiai pilkas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.lime": "Šviesiai žalias kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.magenta": "Purpurinis kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.orange": "Oranžinis kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.pink": "Rausvas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.purple": "Violetinis kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.red": "Raudonas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.white": "Baltas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_left.yellow": "Geltonas kampas kairėje viršuje",
  "block.minecraft.banner.square_top_right.black": "Juodas kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.blue": "Mėlynas kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.brown": "Rudas kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.cyan": "Turkio kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.gray": "Pilkas kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.green": "Žalias kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.light_blue": "Žydras kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.light_gray": "Šviesiai pilkas kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.lime": "Šviesiai žalias kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.magenta": "Purpurinis kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.orange": "Oranžinis kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.pink": "Rausvas kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.purple": "Violetinis kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.red": "Raudonas kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.white": "Baltas kampas dešinėje viršuje",
  "block.minecraft.banner.square_top_right.yellow": "Geltonas kampas dešinėje viršuje",
  "block.minecraft.banner.straight_cross.black": "Juodas kryžius",
  "block.minecraft.banner.straight_cross.blue": "Mėlynas kryžius",
  "block.minecraft.banner.straight_cross.brown": "Rudas kryžius",
  "block.minecraft.banner.straight_cross.cyan": "Turkio kryžius",
  "block.minecraft.banner.straight_cross.gray": "Pilkas kryžius",
  "block.minecraft.banner.straight_cross.green": "Žalias kryžius",
  "block.minecraft.banner.straight_cross.light_blue": "Žydras kryžius",
  "block.minecraft.banner.straight_cross.light_gray": "Šviesiai pilkas kryžius",
  "block.minecraft.banner.straight_cross.lime": "Šviesiai žalias kryžius",
  "block.minecraft.banner.straight_cross.magenta": "Purpurinis kryžius",
  "block.minecraft.banner.straight_cross.orange": "Oranžinis kryžius",
  "block.minecraft.banner.straight_cross.pink": "Rausvas kryžius",
  "block.minecraft.banner.straight_cross.purple": "Violetinis kryžius",
  "block.minecraft.banner.straight_cross.red": "Raudonas kryžius",
  "block.minecraft.banner.straight_cross.white": "Baltas kryžius",
  "block.minecraft.banner.straight_cross.yellow": "Geltonas kryžius",
  "block.minecraft.banner.stripe_bottom.black": "Juoda horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.blue": "Mėlyna horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.brown": "Ruda horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.cyan": "Turkio horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.gray": "Pilka horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.green": "Žalia horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.light_blue": "Žydra horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.light_gray": "Šviesiai pilka horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.lime": "Šviesiai žalia horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.magenta": "Purpurinė horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.orange": "Oranžinė horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.pink": "Rausva horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.purple": "Violetinė horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.red": "Raudona horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.white": "Balta horizontali juosta apačioje",
  "block.minecraft.banner.stripe_bottom.yellow": "Geltona horizontali juosta apačioje",
  "block.minecraft.banner.stripe_center.black": "Juoda vertikali juosta centre",
  "block.minecraft.banner.stripe_center.blue": "Mėlyna vertikali juosta centre",
  "block.minecraft.banner.stripe_center.brown": "Ruda vertikali juosta centre",
  "block.minecraft.banner.stripe_center.cyan": "Turkio vertikali juosta centre",
  "block.minecraft.banner.stripe_center.gray": "Pilka vertikali juosta centre",
  "block.minecraft.banner.stripe_center.green": "Žalia vertikali juosta centre",
  "block.minecraft.banner.stripe_center.light_blue": "Žydra vertikali juosta centre",
  "block.minecraft.banner.stripe_center.light_gray": "Šviesiai pilka vertikali juosta centre",
  "block.minecraft.banner.stripe_center.lime": "Šviesiai žalia vertikali juosta centre",
  "block.minecraft.banner.stripe_center.magenta": "Purpurinė vertikali juosta centre",
  "block.minecraft.banner.stripe_center.orange": "Oranžinė vertikali juosta centre",
  "block.minecraft.banner.stripe_center.pink": "Rausva vertikali juosta centre",
  "block.minecraft.banner.stripe_center.purple": "Violetinė vertikali juosta centre",
  "block.minecraft.banner.stripe_center.red": "Raudona vertikali juosta centre",
  "block.minecraft.banner.stripe_center.white": "Balta vertikali juosta centre",
  "block.minecraft.banner.stripe_center.yellow": "Geltona vertikali juosta centre",
  "block.minecraft.banner.stripe_downleft.black": "Juoda įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.blue": "Mėlyna įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.brown": "Ruda įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.cyan": "Turkio įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.gray": "Pilka įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.green": "Žalia įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.light_blue": "Žydra įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.light_gray": "Šviesiai pilka įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.lime": "Šviesiai žalia įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.magenta": "Purpurinė įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.orange": "Oranžinė įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.pink": "Rausva įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.purple": "Violetinė įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.red": "Raudona įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.white": "Balta įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downleft.yellow": "Geltona įstriža dešininė juosta",
  "block.minecraft.banner.stripe_downright.black": "Juoda įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.blue": "Mėlyna įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.brown": "Ruda įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.cyan": "Turkio įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.gray": "Pilka įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.green": "Žalia įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.light_blue": "Žydra įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.light_gray": "Šviesiai pilka įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.lime": "Šviesiai žalia įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.magenta": "Purpurinė įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.orange": "Oranžinė įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.pink": "Rausva įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.purple": "Violetinė įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.red": "Raudona įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.white": "Balta įstriža kairinė juosta",
  "block.minecraft.banner.stripe_downright.yellow": "Geltona įstriža kairinė juosta",
  "block.minecraft.banner.stripe_left.black": "Juoda vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.blue": "Mėlyna vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.brown": "Ruda vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.cyan": "Turkio vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.gray": "Pilka vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.green": "Žalia vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.light_blue": "Žydra vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.light_gray": "Šviesiai pilka vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.lime": "Šviesiai žalia vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.magenta": "Violetinė vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.orange": "Oranžinė vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.pink": "Rausva vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.purple": "Violetinė vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.red": "Raudona vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.white": "Balta vertikali juosta kairėje",
  "block.minecraft.banner.stripe_left.yellow": "Geltona vertikali juosta kairėje",
  "block.minecraft.banner.stripe_middle.black": "Juoda horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.blue": "Mėlyna horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.brown": "Ruda horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.cyan": "Turkio horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.gray": "Pilka horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.green": "Žalia horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.light_blue": "Žydra horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.light_gray": "Šviesiai pilka horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.lime": "Šviesiai žalia horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.magenta": "Purpurinė horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.orange": "Oranžinė horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.pink": "Rausva horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.purple": "Violetinė horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.red": "Raudona horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.white": "Balta horizontali juosta centre",
  "block.minecraft.banner.stripe_middle.yellow": "Geltona horizontali juosta centre",
  "block.minecraft.banner.stripe_right.black": "Juoda vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.blue": "Mėlyna vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.brown": "Ruda vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.cyan": "Turkio vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.gray": "Pilka vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.green": "Žalia vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.light_blue": "Žydra vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.light_gray": "Šviesiai pilka vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.lime": "Šviesiai žalia vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.magenta": "Purpurinė vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.orange": "Oranžinė vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.pink": "Rausva vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.purple": "Violetinė vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.red": "Raudona vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.white": "Balta vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_right.yellow": "Geltona vertikali juosta dešinėje",
  "block.minecraft.banner.stripe_top.black": "Juoda horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.blue": "Mėlyna horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.brown": "Ruda horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.cyan": "Turkio horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.gray": "Pilka horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.green": "Žalia horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.light_blue": "Žydra horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.light_gray": "Šviesiai pilka horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.lime": "Šviesiai žalia horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.magenta": "Purpurinė horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.orange": "Oranžinė horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.pink": "Rausva horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.purple": "Violetinė horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.red": "Raudona horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.white": "Balta horizontali juosta viršuje",
  "block.minecraft.banner.stripe_top.yellow": "Geltona horizontali juosta viršuje",
  "block.minecraft.banner.triangle_bottom.black": "Juodas trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.blue": "Mėlynas trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.brown": "Rudas trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.cyan": "Turkio trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.gray": "Pilkas trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.green": "Žalias trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.light_blue": "Žydras trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.light_gray": "Šviesiai pilkas trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.lime": "Šviesiai žalias trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.magenta": "Purpurinis trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.orange": "Oranžinis trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.pink": "Rausvas trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.purple": "Violetinis trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.red": "Raudonas trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.white": "Baltas trikampis apačioje",
  "block.minecraft.banner.triangle_bottom.yellow": "Geltonas trikampis apačioje",
  "block.minecraft.banner.triangle_top.black": "Juodas trikampis viršuje",
  "block.minecraft.banner.triangle_top.blue": "Mėlynas trikampis viršuje",
  "block.minecraft.banner.triangle_top.brown": "Rudas trikampis viršuje",
  "block.minecraft.banner.triangle_top.cyan": "Turkio trikampis viršuje",
  "block.minecraft.banner.triangle_top.gray": "Pilkas trikampis viršuje",
  "block.minecraft.banner.triangle_top.green": "Žalias trikampis viršuje",
  "block.minecraft.banner.triangle_top.light_blue": "Žydras trikampis viršuje",
  "block.minecraft.banner.triangle_top.light_gray": "Šviesiai pilkas trikampis viršuje",
  "block.minecraft.banner.triangle_top.lime": "Šviesiai žalias trikampis viršuje",
  "block.minecraft.banner.triangle_top.magenta": "Purpurinis trikampis viršuje",
  "block.minecraft.banner.triangle_top.orange": "Oranžinis trikampis viršuje",
  "block.minecraft.banner.triangle_top.pink": "Rausvas trikampis viršuje",
  "block.minecraft.banner.triangle_top.purple": "Violetinis trikampis viršuje",
  "block.minecraft.banner.triangle_top.red": "Raudonas trikampis viršuje",
  "block.minecraft.banner.triangle_top.white": "Baltas trikampis viršuje",
  "block.minecraft.banner.triangle_top.yellow": "Geltonas trikampis viršuje",
  "block.minecraft.banner.triangles_bottom.black": "Juodos bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.blue": "Mėlynos bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.brown": "Rudos bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.cyan": "Turkio bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.gray": "Pilkos bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.green": "Žalios bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.light_blue": "Žydros bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.light_gray": "Šviesiai pilkos bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.lime": "Šviesiai žalios bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.magenta": "Purpurinės bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.orange": "Oranžinės bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.pink": "Rausvos bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.purple": "Violetinės bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.red": "Raudonos bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.white": "Baltos bangelės apačioje",
  "block.minecraft.banner.triangles_bottom.yellow": "Geltonos bangelės apačioje",
  "block.minecraft.banner.triangles_top.black": "Juodos bangelės viršuje",
  "block.minecraft.banner.triangles_top.blue": "Mėlynos bangelės viršuje",
  "block.minecraft.banner.triangles_top.brown": "Rudos bangelės viršuje",
  "block.minecraft.banner.triangles_top.cyan": "Turkio bangelės viršuje",
  "block.minecraft.banner.triangles_top.gray": "Pilkos bangelės viršuje",
  "block.minecraft.banner.triangles_top.green": "Žalios bangelės viršuje",
  "block.minecraft.banner.triangles_top.light_blue": "Žydros bangelės viršuje",
  "block.minecraft.banner.triangles_top.light_gray": "Šviesiai pilkos bangelės viršuje",
  "block.minecraft.banner.triangles_top.lime": "Šviesiai žalios bangelės viršuje",
  "block.minecraft.banner.triangles_top.magenta": "Purpurinės bangelės viršuje",
  "block.minecraft.banner.triangles_top.orange": "Oranžinės bangelės viršuje",
  "block.minecraft.banner.triangles_top.pink": "Rausvos bangelės viršuje",
  "block.minecraft.banner.triangles_top.purple": "Violetinės bangelės viršuje",
  "block.minecraft.banner.triangles_top.red": "Raudonos bangelės viršuje",
  "block.minecraft.banner.triangles_top.white": "Baltos bangelės viršuje",
  "block.minecraft.banner.triangles_top.yellow": "Geltonos bangelės viršuje",
  "block.minecraft.barrel": "Statinė",
  "block.minecraft.barrier": "Barjeras",
  "block.minecraft.basalt": "Bazaltas",
  "block.minecraft.beacon": "Švyturys",
  "block.minecraft.beacon.primary": "Pirminė galia",
  "block.minecraft.beacon.secondary": "Antrinė galia",
  "block.minecraft.bed.no_sleep": "Galite miegoti tik naktį arba per audras",
  "block.minecraft.bed.not_safe": "Dabar negalite ilsėtis; šalia yra monstrų",
  "block.minecraft.bed.obstructed": "Ši lova užstatyta",
  "block.minecraft.bed.occupied": "Ši lova užimta",
  "block.minecraft.bed.too_far_away": "Dabar negalite ilsėtis; lova per toli",
  "block.minecraft.bedrock": "Pamatakmenis",
  "block.minecraft.bee_nest": "Bičių lizdas",
  "block.minecraft.beehive": "Avilys",
  "block.minecraft.beetroots": "Burokai",
  "block.minecraft.bell": "Varpas",
  "block.minecraft.big_dripleaf": "Didelis varvalapis",
  "block.minecraft.big_dripleaf_stem": "Didelis varvalapio stiebas",
  "block.minecraft.birch_button": "Beržo mygtukas",
  "block.minecraft.birch_door": "Beržo durys",
  "block.minecraft.birch_fence": "Beržo tvora",
  "block.minecraft.birch_fence_gate": "Beržo varteliai",
  "block.minecraft.birch_hanging_sign": "Beržo kabantis ženklas",
  "block.minecraft.birch_leaves": "Beržo lapai",
  "block.minecraft.birch_log": "Beržo rąstas",
  "block.minecraft.birch_planks": "Beržo lentos",
  "block.minecraft.birch_pressure_plate": "Beržinė slėgio plokštė",
  "block.minecraft.birch_sapling": "Beržo sodinukas",
  "block.minecraft.birch_shelf": "Beržo lentyna",
  "block.minecraft.birch_sign": "Beržo ženklas",
  "block.minecraft.birch_slab": "Beržo pusblokis",
  "block.minecraft.birch_stairs": "Beržo laiptai",
  "block.minecraft.birch_trapdoor": "Beržo liukas",
  "block.minecraft.birch_wall_hanging_sign": "Beržo sienos kabantis ženklas",
  "block.minecraft.birch_wall_sign": "Beržo sienos ženklas",
  "block.minecraft.birch_wood": "Beržo medis",
  "block.minecraft.black_banner": "Juoda vėliava",
  "block.minecraft.black_bed": "Juoda lova",
  "block.minecraft.black_candle": "Juoda žvakė",
  "block.minecraft.black_candle_cake": "Tortas su juoda žvake",
  "block.minecraft.black_carpet": "Juodas kilimas",
  "block.minecraft.black_concrete": "Juodas betonas",
  "block.minecraft.black_concrete_powder": "Juodas cementas",
  "block.minecraft.black_glazed_terracotta": "Juoda glazūruota terakota",
  "block.minecraft.black_shulker_box": "Juoda šulkerio dėžė",
  "block.minecraft.black_stained_glass": "Juodas dažytas stiklas",
  "block.minecraft.black_stained_glass_pane": "Juoda dažyto stiklo plokštė",
  "block.minecraft.black_terracotta": "Juoda terakota",
  "block.minecraft.black_wool": "Juoda vilna",
  "block.minecraft.blackstone": "Juodakmenis",
  "block.minecraft.blackstone_slab": "Juodakmenio pusblokis",
  "block.minecraft.blackstone_stairs": "Juodakmenio laiptai",
  "block.minecraft.blackstone_wall": "Juodakmenio siena",
  "block.minecraft.blast_furnace": "Aukštakrosnė",
  "block.minecraft.blue_banner": "Mėlyna vėliava",
  "block.minecraft.blue_bed": "Mėlyna lova",
  "block.minecraft.blue_candle": "Mėlyna žvakė",
  "block.minecraft.blue_candle_cake": "Tortas su mėlyna žvake",
  "block.minecraft.blue_carpet": "Mėlynas kilimas",
  "block.minecraft.blue_concrete": "Mėlynas betonas",
  "block.minecraft.blue_concrete_powder": "Mėlynas cementas",
  "block.minecraft.blue_glazed_terracotta": "Mėlyna glazūruota terakota",
  "block.minecraft.blue_ice": "Mėlynasis ledas",
  "block.minecraft.blue_orchid": "Mėlynoji orchidėja",
  "block.minecraft.blue_shulker_box": "Mėlyna šulkerio dėžė",
  "block.minecraft.blue_stained_glass": "Mėlynas dažytas stiklas",
  "block.minecraft.blue_stained_glass_pane": "Mėlyna dažyto stiklo plokštė",
  "block.minecraft.blue_terracotta": "Mėlyna terakota",
  "block.minecraft.blue_wool": "Mėlyna vilna",
  "block.minecraft.bone_block": "Kaulų blokas",
  "block.minecraft.bookshelf": "Knygų lentyna",
  "block.minecraft.brain_coral": "Smegeninis koralas",
  "block.minecraft.brain_coral_block": "Smegeninis koralo blokas",
  "block.minecraft.brain_coral_fan": "Smegeninis koralas vėduoklė",
  "block.minecraft.brain_coral_wall_fan": "Smegeninis sienos koralas vėduoklė",
  "block.minecraft.brewing_stand": "Eliksyrų stovas",
  "block.minecraft.brick_slab": "Plytų pusblokis",
  "block.minecraft.brick_stairs": "Plytų laiptai",
  "block.minecraft.brick_wall": "Plytų siena",
  "block.minecraft.bricks": "Plytos",
  "block.minecraft.brown_banner": "Ruda vėliava",
  "block.minecraft.brown_bed": "Ruda lova",
  "block.minecraft.brown_candle": "Ruda žvakė",
  "block.minecraft.brown_candle_cake": "Tortas su ruda žvake",
  "block.minecraft.brown_carpet": "Rudas kilimas",
  "block.minecraft.brown_concrete": "Rudas betonas",
  "block.minecraft.brown_concrete_powder": "Rudas cementas",
  "block.minecraft.brown_glazed_terracotta": "Ruda glazūruota terakota",
  "block.minecraft.brown_mushroom": "Rudas grybas",
  "block.minecraft.brown_mushroom_block": "Rudo grybo blokas",
  "block.minecraft.brown_shulker_box": "Ruda šulkerio dėžė",
  "block.minecraft.brown_stained_glass": "Rudas dažytas stiklas",
  "block.minecraft.brown_stained_glass_pane": "Ruda dažyto stiklo plokštė",
  "block.minecraft.brown_terracotta": "Ruda terakota",
  "block.minecraft.brown_wool": "Ruda vilna",
  "block.minecraft.bubble_column": "Burbulų stulpas",
  "block.minecraft.bubble_coral": "Burbulinis koralas",
  "block.minecraft.bubble_coral_block": "Burbulinis koralo blokas",
  "block.minecraft.bubble_coral_fan": "Burbulinis koralas vėduoklė",
  "block.minecraft.bubble_coral_wall_fan": "Burbulinis sienos koralas vėduoklė",
  "block.minecraft.budding_amethyst": "Augantis ametisto blokas",
  "block.minecraft.bush": "Krūmas",
  "block.minecraft.cactus": "Kaktusas",
  "block.minecraft.cactus_flower": "Kaktuso gėlė",
  "block.minecraft.cake": "Tortas",
  "block.minecraft.calcite": "Kalcitas",
  "block.minecraft.calibrated_sculk_sensor": "Kalibruotas sculko sensorius",
  "block.minecraft.campfire": "Laužas",
  "block.minecraft.candle": "Žvakė",
  "block.minecraft.candle_cake": "Tortas su žvake",
  "block.minecraft.carrots": "Morkos",
  "block.minecraft.cartography_table": "Kartografijos stalas",
  "block.minecraft.carved_pumpkin": "Išskobtas moliūgas",
  "block.minecraft.cauldron": "Katilas",
  "block.minecraft.cave_air": "Urvų oras",
  "block.minecraft.cave_vines": "Urvų vijokliai",
  "block.minecraft.cave_vines_plant": "Urvų vijoklių augalas",
  "block.minecraft.chain": "Grandinė",
  "block.minecraft.chain_command_block": "Grandininis komandos blokas",
  "block.minecraft.cherry_button": "Vyšnios mygtukas",
  "block.minecraft.cherry_door": "Vyšnios durys",
  "block.minecraft.cherry_fence": "Vyšnios tvora",
  "block.minecraft.cherry_fence_gate": "Vyšnios varteliai",
  "block.minecraft.cherry_hanging_sign": "Vyšnios kabantis ženklas",
  "block.minecraft.cherry_leaves": "Vyšnios lapai",
  "block.minecraft.cherry_log": "Vyšnios rąstas",
  "block.minecraft.cherry_planks": "Vyšnios lentos",
  "block.minecraft.cherry_pressure_plate": "Vyšnios slėgio plokštė",
  "block.minecraft.cherry_sapling": "Vyšnios sodinukas",
  "block.minecraft.cherry_shelf": "Vyšnios lentyna",
  "block.minecraft.cherry_sign": "Vyšnios ženklas",
  "block.minecraft.cherry_slab": "Vyšnios pusblokis",
  "block.minecraft.cherry_stairs": "Vyšnios laiptai",
  "block.minecraft.cherry_trapdoor": "Vyšnios liukas",
  "block.minecraft.cherry_wall_hanging_sign": "Vyšnios sienos kabantis ženklas",
  "block.minecraft.cherry_wall_sign": "Vyšnios sienos ženklas",
  "block.minecraft.cherry_wood": "Vyšnios medis",
  "block.minecraft.chest": "Skrynia",
  "block.minecraft.chipped_anvil": "Įdaužtas priekalas",
  "block.minecraft.chiseled_bookshelf": "Išdrožinėta knygų lentyna",
  "block.minecraft.chiseled_copper": "Raižytas varis",
  "block.minecraft.chiseled_deepslate": "Raižytas gilakmenis",
  "block.minecraft.chiseled_nether_bricks": "Raižytos Netherio plytos",
  "block.minecraft.chiseled_polished_blackstone": "Raižytas šlifuotas juodakmenis",
  "block.minecraft.chiseled_quartz_block": "Raižytas kvarco blokas",
  "block.minecraft.chiseled_red_sandstone": "Raižytas raudonasis smiltainis",
  "block.minecraft.chiseled_resin_bricks": "Raižytos sakų plytos",
  "block.minecraft.chiseled_sandstone": "Raižytas smiltainis",
  "block.minecraft.chiseled_stone_bricks": "Raižytos akmens plytos",
  "block.minecraft.chiseled_tuff": "Raižytas tufas",
  "block.minecraft.chiseled_tuff_bricks": "Raižytos tufo plytos",
  "block.minecraft.chorus_flower": "Koruso gėlė",
  "block.minecraft.chorus_plant": "Koruso augalas",
  "block.minecraft.clay": "Molis",
  "block.minecraft.closed_eyeblossom": "Uždara akižiedė",
  "block.minecraft.coal_block": "Anglies blokas",
  "block.minecraft.coal_ore": "Anglies rūda",
  "block.minecraft.coarse_dirt": "Šiurkšti žemė",
  "block.minecraft.cobbled_deepslate": "Gilakmenio skalda",
  "block.minecraft.cobbled_deepslate_slab": "Gilakmenio skaldos pusblokis",
  "block.minecraft.cobbled_deepslate_stairs": "Gilakmenio skaldos laiptai",
  "block.minecraft.cobbled_deepslate_wall": "Gilakmenio skaldos siena",
  "block.minecraft.cobblestone": "Akmens skalda",
  "block.minecraft.cobblestone_slab": "Akmens skaldos pusblokis",
  "block.minecraft.cobblestone_stairs": "Akmens skaldos laiptai",
  "block.minecraft.cobblestone_wall": "Akmens skaldos siena",
  "block.minecraft.cobweb": "Voratinklis",
  "block.minecraft.cocoa": "Kakava",
  "block.minecraft.command_block": "Komandos blokas",
  "block.minecraft.comparator": "Redstono komparatorius",
  "block.minecraft.composter": "Komposteris",
  "block.minecraft.conduit": "Jūros kanalas",
  "block.minecraft.copper_bars": "Varinės grotos",
  "block.minecraft.copper_block": "Vario blokas",
  "block.minecraft.copper_bulb": "Varinė lemputė",
  "block.minecraft.copper_chain": "Varinė grandinė",
  "block.minecraft.copper_chest": "Varinė skrynia",
  "block.minecraft.copper_door": "Varinės durys",
  "block.minecraft.copper_golem_statue": "Varinio golemo statula",
  "block.minecraft.copper_grate": "Varinės grotelės",
  "block.minecraft.copper_lantern": "Varinis žibintas",
  "block.minecraft.copper_ore": "Vario rūda",
  "block.minecraft.copper_torch": "Varinis deglas",
  "block.minecraft.copper_trapdoor": "Vario liukas",
  "block.minecraft.copper_wall_torch": "Varinis sienos deglas",
  "block.minecraft.cornflower": "Rugiagėlė",
  "block.minecraft.cracked_deepslate_bricks": "Sutrūkinėjusios gilakmenio plytos",
  "block.minecraft.cracked_deepslate_tiles": "Sutrūkinėjusios gilakmenio plytelės",
  "block.minecraft.cracked_nether_bricks": "Sutrūkinėjusios Netherio plytos",
  "block.minecraft.cracked_polished_blackstone_bricks": "Sutrūkinėjusio šlifuoto juodakmenio plytos",
  "block.minecraft.cracked_stone_bricks": "Sutrūkinėjusios akmens plytos",
  "block.minecraft.crafter": "Kūrėjas",
  "block.minecraft.crafting_table": "Darbastalis",
  "block.minecraft.creaking_heart": "Girgždžio širdis",
  "block.minecraft.creeper_head": "Kryperio galva",
  "block.minecraft.creeper_wall_head": "Kryperio galva ant sienos",
  "block.minecraft.crimson_button": "Raudonio mygtukas",
  "block.minecraft.crimson_door": "Raudonio durys",
  "block.minecraft.crimson_fence": "Raudonio tvora",
  "block.minecraft.crimson_fence_gate": "Raudonio vartai",
  "block.minecraft.crimson_fungus": "Raudonio grybas",
  "block.minecraft.crimson_hanging_sign": "Raudonio kabantis ženklas",
  "block.minecraft.crimson_hyphae": "Raudonio hifai",
  "block.minecraft.crimson_nylium": "Raudonio grybiena",
  "block.minecraft.crimson_planks": "Raudonio lentos",
  "block.minecraft.crimson_pressure_plate": "Raudonio slėgio plokštė",
  "block.minecraft.crimson_roots": "Raudonio šaknys",
  "block.minecraft.crimson_shelf": "Raudonio lentyna",
  "block.minecraft.crimson_sign": "Raudonio ženklas",
  "block.minecraft.crimson_slab": "Raudonio pusblokis",
  "block.minecraft.crimson_stairs": "Raudonio laiptai",
  "block.minecraft.crimson_stem": "Raudonio stiebas",
  "block.minecraft.crimson_trapdoor": "Raudonio liukas",
  "block.minecraft.crimson_wall_hanging_sign": "Raudonio sienos kabantis ženklas",
  "block.minecraft.crimson_wall_sign": "Raudonio sienos ženklas",
  "block.minecraft.crying_obsidian": "Ašarotas obsidianas",
  "block.minecraft.cut_copper": "Pjauto vario blokas",
  "block.minecraft.cut_copper_slab": "Pjauto vario pusblokis",
  "block.minecraft.cut_copper_stairs": "Pjauto vario laiptai",
  "block.minecraft.cut_red_sandstone": "Šlifuotas raudonasis smiltainis",
  "block.minecraft.cut_red_sandstone_slab": "Šlifuoto raudonojo smiltainio pusblokis",
  "block.minecraft.cut_sandstone": "Šlifuotas smiltainis",
  "block.minecraft.cut_sandstone_slab": "Šlifuoto smiltainio pusblokis",
  "block.minecraft.cyan_banner": "Tamsiai žydra vėliava",
  "block.minecraft.cyan_bed": "Tamsiai žydra lova",
  "block.minecraft.cyan_candle": "Tamsiai žydra žvakė",
  "block.minecraft.cyan_candle_cake": "Tortas su tamsiai žydra žvake",
  "block.minecraft.cyan_carpet": "Tamsiai žydras kilimas",
  "block.minecraft.cyan_concrete": "Tamsiai žydras betonas",
  "block.minecraft.cyan_concrete_powder": "Tamsiai žydras cementas",
  "block.minecraft.cyan_glazed_terracotta": "Tamsiai žydra glazūruota terakota",
  "block.minecraft.cyan_shulker_box": "Tamsiai žydra šulkerio dėžė",
  "block.minecraft.cyan_stained_glass": "Tamsiai žydras dažytas stiklas",
  "block.minecraft.cyan_stained_glass_pane": "Tamsiai žydra dažyto stiklo plokštė",
  "block.minecraft.cyan_terracotta": "Tamsiai žydra terakota",
  "block.minecraft.cyan_wool": "Tamsiai žydra vilna",
  "block.minecraft.damaged_anvil": "Apgadintas priekalas",
  "block.minecraft.dandelion": "Pienė",
  "block.minecraft.dark_oak_button": "Tamsiojo ąžuolo mygtukas",
  "block.minecraft.dark_oak_door": "Tamsiojo ąžuolo durys",
  "block.minecraft.dark_oak_fence": "Tamsiojo ąžuolo tvora",
  "block.minecraft.dark_oak_fence_gate": "Tamsiojo ąžuolo varteliai",
  "block.minecraft.dark_oak_hanging_sign": "Tamsiojo ąžuolo kabantis ženklas",
  "block.minecraft.dark_oak_leaves": "Tamsiojo ąžuolo lapai",
  "block.minecraft.dark_oak_log": "Tamsiojo ąžuolo rąstas",
  "block.minecraft.dark_oak_planks": "Tamsiojo ąžuolo lentos",
  "block.minecraft.dark_oak_pressure_plate": "Tamsiojo ąžuolo slėgio plokštė",
  "block.minecraft.dark_oak_sapling": "Tamsiojo ąžuolo sodinukas",
  "block.minecraft.dark_oak_shelf": "Tamsiojo ąžuolo lentyna",
  "block.minecraft.dark_oak_sign": "Tamsiojo ąžuolo ženklas",
  "block.minecraft.dark_oak_slab": "Tamsiojo ąžuolo pusblokis",
  "block.minecraft.dark_oak_stairs": "Tamsiojo ąžuolo laiptai",
  "block.minecraft.dark_oak_trapdoor": "Tamsiojo ąžuolo liukas",
  "block.minecraft.dark_oak_wall_hanging_sign": "Tamsiojo ąžuolo sienos kabantis ženklas",
  "block.minecraft.dark_oak_wall_sign": "Tamsiojo ąžuolo sienos ženklas",
  "block.minecraft.dark_oak_wood": "Tamsiojo ąžuolo medis",
  "block.minecraft.dark_prismarine": "Tamsusis prizmarinas",
  "block.minecraft.dark_prismarine_slab": "Tamsiojo prizmarino pusblokis",
  "block.minecraft.dark_prismarine_stairs": "Tamsiojo prizmarino laiptai",
  "block.minecraft.daylight_detector": "Dienos šviesos jutiklis",
  "block.minecraft.dead_brain_coral": "Negyvas smegeninis koralas",
  "block.minecraft.dead_brain_coral_block": "Negyvas smegeninis koralo blokas",
  "block.minecraft.dead_brain_coral_fan": "Negyvas smegeninis koralas vėduoklė",
  "block.minecraft.dead_brain_coral_wall_fan": "Negyvas smegeninis sienos koralas vėduoklė",
  "block.minecraft.dead_bubble_coral": "Negyvas burbulinis koralas",
  "block.minecraft.dead_bubble_coral_block": "Negyvas burbulinis koralo blokas",
  "block.minecraft.dead_bubble_coral_fan": "Negyvas burbulinis koralas vėduoklė",
  "block.minecraft.dead_bubble_coral_wall_fan": "Negyvas burbulinis sienos koralas vėduoklė",
  "block.minecraft.dead_bush": "Negyvas krūmas",
  "block.minecraft.dead_fire_coral": "Negyvas ugninis koralas",
  "block.minecraft.dead_fire_coral_block": "Negyvas ugninis koralo blokas",
  "block.minecraft.dead_fire_coral_fan": "Negyvas ugninis koralas vėduoklė",
  "block.minecraft.dead_fire_coral_wall_fan": "Negyvas ugninis sienos koralas vėduoklė",
  "block.minecraft.dead_horn_coral": "Negyvas raguotas koralas",
  "block.minecraft.dead_horn_coral_block": "Negyvas raguotas koralo blokas",
  "block.minecraft.dead_horn_coral_fan": "Negyvas raguotas koralas vėduoklė",
  "block.minecraft.dead_horn_coral_wall_fan": "Negyvas raguotas sienos koralas vėduoklė",
  "block.minecraft.dead_tube_coral": "Negyvas vamzdinis koralas",
  "block.minecraft.dead_tube_coral_block": "Negyvas vamzdinis koralo blokas",
  "block.minecraft.dead_tube_coral_fan": "Negyvas vamzdinis koralas vėduoklė",
  "block.minecraft.dead_tube_coral_wall_fan": "Negyvas vamzdinis sienos koralas vėduoklė",
  "block.minecraft.decorated_pot": "Dekoratyvinė puodynė",
  "block.minecraft.deepslate": "Gilakmenis",
  "block.minecraft.deepslate_brick_slab": "Gilakmenio plytų pusblokis",
  "block.minecraft.deepslate_brick_stairs": "Gilakmenio plytų laiptai",
  "block.minecraft.deepslate_brick_wall": "Gilakmenio plytų siena",
  "block.minecraft.deepslate_bricks": "Gilakmenio plytos",
  "block.minecraft.deepslate_coal_ore": "Gilakmenio anglies rūda",
  "block.minecraft.deepslate_copper_ore": "Gilakmenio vario rūda",
  "block.minecraft.deepslate_diamond_ore": "Gilakmenio deimanto rūda",
  "block.minecraft.deepslate_emerald_ore": "Gilakmenio smaragdo rūda",
  "block.minecraft.deepslate_gold_ore": "Gilakmenio aukso rūda",
  "block.minecraft.deepslate_iron_ore": "Gilakmenio geležies rūda",
  "block.minecraft.deepslate_lapis_ore": "Gilakmenio lazurito rūda",
  "block.minecraft.deepslate_redstone_ore": "Gilakmenio redstono rūda",
  "block.minecraft.deepslate_tile_slab": "Gilakmenio plytelių pusblokis",
  "block.minecraft.deepslate_tile_stairs": "Gilakmenio plytelių laiptai",
  "block.minecraft.deepslate_tile_wall": "Gilakmenio plytelių siena",
  "block.minecraft.deepslate_tiles": "Gilakmenio plytelės",
  "block.minecraft.detector_rail": "Detektoriniai bėgiai",
  "block.minecraft.diamond_block": "Deimanto blokas",
  "block.minecraft.diamond_ore": "Deimanto rūda",
  "block.minecraft.diorite": "Dioritas",
  "block.minecraft.diorite_slab": "Diorito pusblokis",
  "block.minecraft.diorite_stairs": "Diorito laiptai",
  "block.minecraft.diorite_wall": "Diorito siena",
  "block.minecraft.dirt": "Žemė",
  "block.minecraft.dirt_path": "Takas",
  "block.minecraft.dispenser": "Dalytuvas",
  "block.minecraft.dragon_egg": "Drakonės kiaušinis",
  "block.minecraft.dragon_head": "Drakonės galva",
  "block.minecraft.dragon_wall_head": "Drakonės galva ant sienos",
  "block.minecraft.dried_ghast": "Sudžiūvęs ghastas",
  "block.minecraft.dried_kelp_block": "Džiovintų rudadumblių blokas",
  "block.minecraft.dripstone_block": "Varvakmenio blokas",
  "block.minecraft.dropper": "Mėtytuvas",
  "block.minecraft.emerald_block": "Smaragdo blokas",
  "block.minecraft.emerald_ore": "Smaragdo rūda",
  "block.minecraft.enchanting_table": "Kerų stalas",
  "block.minecraft.end_gateway": "Endo tarpuvartė",
  "block.minecraft.end_portal": "Endo portalas",
  "block.minecraft.end_portal_frame": "Endo portalo rėmas",
  "block.minecraft.end_rod": "Endo strypas",
  "block.minecraft.end_stone": "Endakmenis",
  "block.minecraft.end_stone_brick_slab": "Endakmenio plytų pusblokis",
  "block.minecraft.end_stone_brick_stairs": "Endakmenio plytų laiptai",
  "block.minecraft.end_stone_brick_wall": "Endakmenio plytų siena",
  "block.minecraft.end_stone_bricks": "Endakmenio plytos",
  "block.minecraft.ender_chest": "Enderio skrynia",
  "block.minecraft.exposed_chiseled_copper": "Paveiktas raižytas varis",
  "block.minecraft.exposed_copper": "Paveiktas vario blokas",
  "block.minecraft.exposed_copper_bars": "Paveiktos varinės grotos",
  "block.minecraft.exposed_copper_bulb": "Paveikta varinė lemputė",
  "block.minecraft.exposed_copper_chain": "Paveikta varinė grandinė",
  "block.minecraft.exposed_copper_chest": "Paveikta varinė skrynia",
  "block.minecraft.exposed_copper_door": "Paveiktos varinės durys",
  "block.minecraft.exposed_copper_golem_statue": "Paveikta varinio golemo statula",
  "block.minecraft.exposed_copper_grate": "Paveiktos varinės grotelės",
  "block.minecraft.exposed_copper_lantern": "Paveiktas varinis žibintas",
  "block.minecraft.exposed_copper_trapdoor": "Paveiktas varinis liukas",
  "block.minecraft.exposed_cut_copper": "Paveiktas pjauto vario blokas",
  "block.minecraft.exposed_cut_copper_slab": "Paveikto pjauto vario pusblokis",
  "block.minecraft.exposed_cut_copper_stairs": "Paveikto pjauto vario laiptai",
  "block.minecraft.exposed_lightning_rod": "Paveiktas žaibolaidis",
  "block.minecraft.farmland": "Išarta žemė",
  "block.minecraft.fern": "Papartis",
  "block.minecraft.fire": "Ugnis",
  "block.minecraft.fire_coral": "Ugninis koralas",
  "block.minecraft.fire_coral_block": "Ugninis koralo blokas",
  "block.minecraft.fire_coral_fan": "Ugninis koralas vėduoklė",
  "block.minecraft.fire_coral_wall_fan": "Ugninis sienos koralas vėduoklė",
  "block.minecraft.firefly_bush": "Jonvabalių krūmas",
  "block.minecraft.fletching_table": "Lankininkų stalas",
  "block.minecraft.flower_pot": "Vazonas",
  "block.minecraft.flowering_azalea": "Žydinti azalija",
  "block.minecraft.flowering_azalea_leaves": "Žydinčios azalijos lapai",
  "block.minecraft.frogspawn": "Varlės ikrai",
  "block.minecraft.frosted_ice": "Užšalęs ledas",
  "block.minecraft.furnace": "Krosnis",
  "block.minecraft.gilded_blackstone": "Auksuotas juodakmenis",
  "block.minecraft.glass": "Stiklas",
  "block.minecraft.glass_pane": "Stiklo plokštė",
  "block.minecraft.glow_lichen": "Švytinčios kerpės",
  "block.minecraft.glowstone": "Šviesakmenis",
  "block.minecraft.gold_block": "Aukso blokas",
  "block.minecraft.gold_ore": "Aukso rūda",
  "block.minecraft.golden_dandelion": "Auksinė kiaulpienė",
  "block.minecraft.granite": "Granitas",
  "block.minecraft.granite_slab": "Granito pusblokis",
  "block.minecraft.granite_stairs": "Granito laiptai",
  "block.minecraft.granite_wall": "Granito siena",
  "block.minecraft.grass": "Žolė",
  "block.minecraft.grass_block": "Žolės blokas",
  "block.minecraft.gravel": "Žvyras",
  "block.minecraft.gray_banner": "Pilka vėliava",
  "block.minecraft.gray_bed": "Pilka lova",
  "block.minecraft.gray_candle": "Pilka žvakė",
  "block.minecraft.gray_candle_cake": "Tortas su pilka žvake",
  "block.minecraft.gray_carpet": "Pilkas kilimas",
  "block.minecraft.gray_concrete": "Pilkas betonas",
  "block.minecraft.gray_concrete_powder": "Pilkas cementas",
  "block.minecraft.gray_glazed_terracotta": "Pilka glazūruota terakota",
  "block.minecraft.gray_shulker_box": "Pilka šulkerio dėžė",
  "block.minecraft.gray_stained_glass": "Pilkas dažytas stiklas",
  "block.minecraft.gray_stained_glass_pane": "Pilka dažyto stiklo plokštė",
  "block.minecraft.gray_terracotta": "Pilka terakota",
  "block.minecraft.gray_wool": "Pilka vilna",
  "block.minecraft.green_banner": "Žalia vėliava",
  "block.minecraft.green_bed": "Žalia lova",
  "block.minecraft.green_candle": "Žalia žvakė",
  "block.minecraft.green_candle_cake": "Tortas su žalia žvake",
  "block.minecraft.green_carpet": "Žalias kilimas",
  "block.minecraft.green_concrete": "Žalias betonas",
  "block.minecraft.green_concrete_powder": "Žalias cementas",
  "block.minecraft.green_glazed_terracotta": "Žalia glazūruota terakota",
  "block.minecraft.green_shulker_box": "Žalia šulkerio dėžė",
  "block.minecraft.green_stained_glass": "Žalias dažytas stiklas",
  "block.minecraft.green_stained_glass_pane": "Žalia dažyto stiklo plokštė",
  "block.minecraft.green_terracotta": "Žalia terakota",
  "block.minecraft.green_wool": "Žalia vilna",
  "block.minecraft.grindstone": "Tekėlas",
  "block.minecraft.hanging_roots": "Kabančios šaknys",
  "block.minecraft.hay_block": "Šieno kupeta",
  "block.minecraft.heavy_core": "Svorinė šerdis",
  "block.minecraft.heavy_weighted_pressure_plate": "Sunki svorinė slėgio plokštė",
  "block.minecraft.honey_block": "Medaus blokas",
  "block.minecraft.honeycomb_block": "Medaus korio blokas",
  "block.minecraft.hopper": "Piltuvas",
  "block.minecraft.horn_coral": "Raguotas koralas",
  "block.minecraft.horn_coral_block": "Raguotas koralo blokas",
  "block.minecraft.horn_coral_fan": "Raguotas koralas vėduoklė",
  "block.minecraft.horn_coral_wall_fan": "Raguotas sienos koralas vėduoklė",
  "block.minecraft.ice": "Ledas",
  "block.minecraft.infested_chiseled_stone_bricks": "Užkrėstos raižytos akmens plytos",
  "block.minecraft.infested_cobblestone": "Užkrėsta akmens skalda",
  "block.minecraft.infested_cracked_stone_bricks": "Užkrėstos sutrūkinėjusios akmens plytos",
  "block.minecraft.infested_deepslate": "Užkrėstas gilakmenis",
  "block.minecraft.infested_mossy_stone_bricks": "Užkrėstos samanotos akmens plytos",
  "block.minecraft.infested_stone": "Užkrėstas akmuo",
  "block.minecraft.infested_stone_bricks": "Užkrėstos akmens plytos",
  "block.minecraft.iron_bars": "Geležinės grotos",
  "block.minecraft.iron_block": "Geležies blokas",
  "block.minecraft.iron_chain": "Geležinė grandinė",
  "block.minecraft.iron_door": "Geležinės durys",
  "block.minecraft.iron_ore": "Geležies rūda",
  "block.minecraft.iron_trapdoor": "Geležinis liukas",
  "block.minecraft.jack_o_lantern": "Moliūgo žibintas",
  "block.minecraft.jigsaw": "Dėlionės blokas",
  "block.minecraft.jukebox": "Diskų grotuvas",
  "block.minecraft.jungle_button": "Džiunglių medžio mygtukas",
  "block.minecraft.jungle_door": "Džiunglių medžio durys",
  "block.minecraft.jungle_fence": "Džiunglių medžio tvora",
  "block.minecraft.jungle_fence_gate": "Džiunglių medžio varteliai",
  "block.minecraft.jungle_hanging_sign": "Džiunglių medžio kabantis ženklas",
  "block.minecraft.jungle_leaves": "Džiunglių medžio lapai",
  "block.minecraft.jungle_log": "Džiunglių medžio rąstas",
  "block.minecraft.jungle_planks": "Džiunglių medžio lentos",
  "block.minecraft.jungle_pressure_plate": "Džiunglių medžio slėgio plokštė",
  "block.minecraft.jungle_sapling": "Džiunglių medžio sodinukas",
  "block.minecraft.jungle_shelf": "Džiunglių medžio lentyna",
  "block.minecraft.jungle_sign": "Džiunglių medžio ženklas",
  "block.minecraft.jungle_slab": "Džiunglių medžio pusblokis",
  "block.minecraft.jungle_stairs": "Džiunglių medžio laiptai",
  "block.minecraft.jungle_trapdoor": "Džiunglių medžio liukas",
  "block.minecraft.jungle_wall_hanging_sign": "Džiunglių medžio sienos kabantis ženklas",
  "block.minecraft.jungle_wall_sign": "Džiunglių medžio sienos ženklas",
  "block.minecraft.jungle_wood": "Džiunglių medžio medis",
  "block.minecraft.kelp": "Rudadumbliai",
  "block.minecraft.kelp_plant": "Rudadumblių augalas",
  "block.minecraft.ladder": "Kopėčios",
  "block.minecraft.lantern": "Žibintas",
  "block.minecraft.lapis_block": "Lazurito blokas",
  "block.minecraft.lapis_ore": "Lazurito rūda",
  "block.minecraft.large_amethyst_bud": "Didelis ametisto kristalas",
  "block.minecraft.large_fern": "Didelis papartis",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavos katilas",
  "block.minecraft.leaf_litter": "Lapų kraikas",
  "block.minecraft.lectern": "Pultas",
  "block.minecraft.lever": "Svirtis",
  "block.minecraft.light": "Šviesa",
  "block.minecraft.light_blue_banner": "Žydra vėliava",
  "block.minecraft.light_blue_bed": "Žydra lova",
  "block.minecraft.light_blue_candle": "Žydra žvakė",
  "block.minecraft.light_blue_candle_cake": "Tortas su žydra žvake",
  "block.minecraft.light_blue_carpet": "Žydras kilimas",
  "block.minecraft.light_blue_concrete": "Žydras betonas",
  "block.minecraft.light_blue_concrete_powder": "Žydras cementas",
  "block.minecraft.light_blue_glazed_terracotta": "Žydra glazūruota terakota",
  "block.minecraft.light_blue_shulker_box": "Žydra šulkerio dėžė",
  "block.minecraft.light_blue_stained_glass": "Žydras dažytas stiklas",
  "block.minecraft.light_blue_stained_glass_pane": "Žydra dažyto stiklo plokštė",
  "block.minecraft.light_blue_terracotta": "Žydra terakota",
  "block.minecraft.light_blue_wool": "Žydra vilna",
  "block.minecraft.light_gray_banner": "Šviesiai pilka vėliava",
  "block.minecraft.light_gray_bed": "Šviesiai pilka lova",
  "block.minecraft.light_gray_candle": "Šviesiai pilka žvakė",
  "block.minecraft.light_gray_candle_cake": "Tortas su šviesiai pilka žvake",
  "block.minecraft.light_gray_carpet": "Šviesiai pilkas kilimas",
  "block.minecraft.light_gray_concrete": "Šviesiai pilkas betonas",
  "block.minecraft.light_gray_concrete_powder": "Šviesiai pilkas cementas",
  "block.minecraft.light_gray_glazed_terracotta": "Šviesiai pilka glazūruota terakota",
  "block.minecraft.light_gray_shulker_box": "Šviesiai pilka šulkerio dėžė",
  "block.minecraft.light_gray_stained_glass": "Šviesiai pilkas dažytas stiklas",
  "block.minecraft.light_gray_stained_glass_pane": "Šviesiai pilka dažyto stiklo plokštė",
  "block.minecraft.light_gray_terracotta": "Šviesiai pilka terakota",
  "block.minecraft.light_gray_wool": "Šviesiai pilka vilna",
  "block.minecraft.light_weighted_pressure_plate": "Lengva svorinė slėgio plokštė",
  "block.minecraft.lightning_rod": "Žaibolaidis",
  "block.minecraft.lilac": "Alyva",
  "block.minecraft.lily_of_the_valley": "Pakalnutė",
  "block.minecraft.lily_pad": "Lelijos lapas",
  "block.minecraft.lime_banner": "Šviesiai žalia vėliava",
  "block.minecraft.lime_bed": "Šviesiai žalia lova",
  "block.minecraft.lime_candle": "Šviesiai žalia žvakė",
  "block.minecraft.lime_candle_cake": "Tortas su šviesiai žalia žvake",
  "block.minecraft.lime_carpet": "Šviesiai žalias kilimas",
  "block.minecraft.lime_concrete": "Šviesiai žalias betonas",
  "block.minecraft.lime_concrete_powder": "Šviesiai žalias cementas",
  "block.minecraft.lime_glazed_terracotta": "Šviesiai žalia glazūruota terakota",
  "block.minecraft.lime_shulker_box": "Šviesiai žalia šulkerio dėžė",
  "block.minecraft.lime_stained_glass": "Šviesiai žaliai dažytas stiklas",
  "block.minecraft.lime_stained_glass_pane": "Šviesiai žaliai dažyto stiklo plokštė",
  "block.minecraft.lime_terracotta": "Šviesiai žalia terakota",
  "block.minecraft.lime_wool": "Šviesiai žalia vilna",
  "block.minecraft.lodestone": "Magnetitas",
  "block.minecraft.loom": "Staklės",
  "block.minecraft.magenta_banner": "Šviesiai purpurinė vėliava",
  "block.minecraft.magenta_bed": "Šviesiai purpurinė lova",
  "block.minecraft.magenta_candle": "Šviesiai purpurinė žvakė",
  "block.minecraft.magenta_candle_cake": "Tortas su šviesiai purpurine žvake",
  "block.minecraft.magenta_carpet": "Šviesiai purpurinis kilimas",
  "block.minecraft.magenta_concrete": "Šviesiai purpurinis betonas",
  "block.minecraft.magenta_concrete_powder": "Šviesiai purpurinis cementas",
  "block.minecraft.magenta_glazed_terracotta": "Šviesiai purpurinė glazūruota terakota",
  "block.minecraft.magenta_shulker_box": "Šviesiai purpurinė šulkerio dėžė",
  "block.minecraft.magenta_stained_glass": "Šviesiai purpurinis dažytas stiklas",
  "block.minecraft.magenta_stained_glass_pane": "Šviesiai purpurinė dažyto stiklo plokštė",
  "block.minecraft.magenta_terracotta": "Šviesiai purpurinė terakota",
  "block.minecraft.magenta_wool": "Šviesiai purpurinė vilna",
  "block.minecraft.magma_block": "Magmos blokas",
  "block.minecraft.mangrove_button": "Mangrovės mygtukas",
  "block.minecraft.mangrove_door": "Mangrovės durys",
  "block.minecraft.mangrove_fence": "Mangrovės tvora",
  "block.minecraft.mangrove_fence_gate": "Mangrovės varteliai",
  "block.minecraft.mangrove_hanging_sign": "Mangrovės kabantis ženklas",
  "block.minecraft.mangrove_leaves": "Mangrovės lapai",
  "block.minecraft.mangrove_log": "Mangrovės rąstas",
  "block.minecraft.mangrove_planks": "Mangrovės lentos",
  "block.minecraft.mangrove_pressure_plate": "Mangrovės slėgio plokštė",
  "block.minecraft.mangrove_propagule": "Mangrovės sodinukas",
  "block.minecraft.mangrove_roots": "Mangrovės šaknys",
  "block.minecraft.mangrove_shelf": "Mangrovės lentyna",
  "block.minecraft.mangrove_sign": "Mangrovės ženklas",
  "block.minecraft.mangrove_slab": "Mangrovės pusblokis",
  "block.minecraft.mangrove_stairs": "Mangrovės laiptai",
  "block.minecraft.mangrove_trapdoor": "Mangrovės liukas",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovės sienos kabantis ženklas",
  "block.minecraft.mangrove_wall_sign": "Mangrovės sienos ženklas",
  "block.minecraft.mangrove_wood": "Mangrovės medis",
  "block.minecraft.medium_amethyst_bud": "Vidutinis ametisto kristalas",
  "block.minecraft.melon": "Arbūzas",
  "block.minecraft.melon_stem": "Arbūzo stiebas",
  "block.minecraft.moss_block": "Samanų blokas",
  "block.minecraft.moss_carpet": "Samanų kilimas",
  "block.minecraft.mossy_cobblestone": "Samanota akmens skalda",
  "block.minecraft.mossy_cobblestone_slab": "Samanotos akmens skaldos pusblokis",
  "block.minecraft.mossy_cobblestone_stairs": "Samanotos akmens skaldos laiptai",
  "block.minecraft.mossy_cobblestone_wall": "Samanotos akmens skaldos siena",
  "block.minecraft.mossy_stone_brick_slab": "Samanotų akmenų plytų pusblokis",
  "block.minecraft.mossy_stone_brick_stairs": "Samanotų akmenų plytų laiptai",
  "block.minecraft.mossy_stone_brick_wall": "Samanoto akmens plytų siena",
  "block.minecraft.mossy_stone_bricks": "Samanotos akmens plytos",
  "block.minecraft.moving_piston": "Judantis stūmoklis",
  "block.minecraft.mud": "Purvas",
  "block.minecraft.mud_brick_slab": "Purvo plytų pusblokis",
  "block.minecraft.mud_brick_stairs": "Purvo plytų laiptai",
  "block.minecraft.mud_brick_wall": "Purvo plytų siena",
  "block.minecraft.mud_bricks": "Purvo plytos",
  "block.minecraft.muddy_mangrove_roots": "Purvinos mangrovės šaknys",
  "block.minecraft.mushroom_stem": "Grybo stiebas",
  "block.minecraft.mycelium": "Grybiena",
  "block.minecraft.nether_brick_fence": "Netherio plytų tvora",
  "block.minecraft.nether_brick_slab": "Netherio plytų pusblokis",
  "block.minecraft.nether_brick_stairs": "Netherio plytų laiptai",
  "block.minecraft.nether_brick_wall": "Netherio plytų siena",
  "block.minecraft.nether_bricks": "Netherio plytos",
  "block.minecraft.nether_gold_ore": "Netherio aukso rūda",
  "block.minecraft.nether_portal": "Netherio portalas",
  "block.minecraft.nether_quartz_ore": "Netherio kvarco rūda",
  "block.minecraft.nether_sprouts": "Netherio daigai",
  "block.minecraft.nether_wart": "Netherio gumbas",
  "block.minecraft.nether_wart_block": "Netherio gumbų blokas",
  "block.minecraft.netherite_block": "Netherito blokas",
  "block.minecraft.netherrack": "Netherrakas",
  "block.minecraft.note_block": "Natų blokas",
  "block.minecraft.oak_button": "Ąžuolo mygtukas",
  "block.minecraft.oak_door": "Ąžuolo durys",
  "block.minecraft.oak_fence": "Ąžuolo tvora",
  "block.minecraft.oak_fence_gate": "Varteliai",
  "block.minecraft.oak_hanging_sign": "Ąžuolo kabantis ženklas",
  "block.minecraft.oak_leaves": "Ąžuolo lapai",
  "block.minecraft.oak_log": "Ąžuolo rąstas",
  "block.minecraft.oak_planks": "Ąžuolo lentos",
  "block.minecraft.oak_pressure_plate": "Ąžuolinė slėgio plokštė",
  "block.minecraft.oak_sapling": "Ąžuolo sodinukas",
  "block.minecraft.oak_shelf": "Ąžuolo lentyna",
  "block.minecraft.oak_sign": "Ąžuolinis ženklas",
  "block.minecraft.oak_slab": "Ąžuolo pusblokis",
  "block.minecraft.oak_stairs": "Ąžuolo laiptai",
  "block.minecraft.oak_trapdoor": "Ąžuolo liukas",
  "block.minecraft.oak_wall_hanging_sign": "Ąžuolo sienos kabantis ženklas",
  "block.minecraft.oak_wall_sign": "Ąžuolo sienos ženklas",
  "block.minecraft.oak_wood": "Ąžuolo medis",
  "block.minecraft.observer": "Stebėtojas",
  "block.minecraft.obsidian": "Obsidianas",
  "block.minecraft.ochre_froglight": "Geltona varlialempė",
  "block.minecraft.ominous_banner": "Grėsminga vėliava",
  "block.minecraft.open_eyeblossom": "Atsivėrusi akižiedė",
  "block.minecraft.orange_banner": "Oranžinė vėliava",
  "block.minecraft.orange_bed": "Oranžinė lova",
  "block.minecraft.orange_candle": "Oranžinė žvakė",
  "block.minecraft.orange_candle_cake": "Tortas su oranžine žvake",
  "block.minecraft.orange_carpet": "Oranžinis kilimas",
  "block.minecraft.orange_concrete": "Oranžinis betonas",
  "block.minecraft.orange_concrete_powder": "Oranžinis cementas",
  "block.minecraft.orange_glazed_terracotta": "Oranžinė glazūruota terakota",
  "block.minecraft.orange_shulker_box": "Oranžinė šulkerio dėžė",
  "block.minecraft.orange_stained_glass": "Oranžinis dažytas stiklas",
  "block.minecraft.orange_stained_glass_pane": "Oranžinė dažyto stiklo plokštė",
  "block.minecraft.orange_terracotta": "Oranžinė terakota",
  "block.minecraft.orange_tulip": "Oranžinė tulpė",
  "block.minecraft.orange_wool": "Oranžinė vilna",
  "block.minecraft.oxeye_daisy": "Paprastoji baltagalvė",
  "block.minecraft.oxidized_chiseled_copper": "Oksiduotas raižytas varis",
  "block.minecraft.oxidized_copper": "Oksiduotas vario blokas",
  "block.minecraft.oxidized_copper_bars": "Oksiduotos varinės grotos",
  "block.minecraft.oxidized_copper_bulb": "Oksiduota varinė lemputė",
  "block.minecraft.oxidized_copper_chain": "Oksiduota varinė grandinė",
  "block.minecraft.oxidized_copper_chest": "Oksiduota varinė skrynia",
  "block.minecraft.oxidized_copper_door": "Oksiduotos varinės durys",
  "block.minecraft.oxidized_copper_golem_statue": "Oksiduota varinio golemo statula",
  "block.minecraft.oxidized_copper_grate": "Oksiduotos varinės grotelės",
  "block.minecraft.oxidized_copper_lantern": "Oksiduotas varinis žibintas",
  "block.minecraft.oxidized_copper_trapdoor": "Oksiduotas varinis liukas",
  "block.minecraft.oxidized_cut_copper": "Oksiduotas pjauto vario blokas",
  "block.minecraft.oxidized_cut_copper_slab": "Oksiduoto pjauto vario pusblokis",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksiduoto pjauto vario laiptai",
  "block.minecraft.oxidized_lightning_rod": "Oksiduotas žaibolaidis",
  "block.minecraft.packed_ice": "Suspaustas ledas",
  "block.minecraft.packed_mud": "Suspaustas purvas",
  "block.minecraft.pale_hanging_moss": "Blyškioji kabanti samana",
  "block.minecraft.pale_moss_block": "Blyškiosios samanos blokas",
  "block.minecraft.pale_moss_carpet": "Blyškiosios samanos kilimas",
  "block.minecraft.pale_oak_button": "Blyškiojo ąžuolo mygtukas",
  "block.minecraft.pale_oak_door": "Blyškiojo ąžuolo durys",
  "block.minecraft.pale_oak_fence": "Blyškiojo ąžuolo tvora",
  "block.minecraft.pale_oak_fence_gate": "Blyškiojo ąžuolo varteliai",
  "block.minecraft.pale_oak_hanging_sign": "Blyškiojo ąžuolo kabantis ženklas",
  "block.minecraft.pale_oak_leaves": "Blyškiojo ąžuolo lapai",
  "block.minecraft.pale_oak_log": "Blyškiojo ąžuolo rąstas",
  "block.minecraft.pale_oak_planks": "Blyškiojo ąžuolo lentos",
  "block.minecraft.pale_oak_pressure_plate": "Blyškiojo ąžuolo slėgio plokštė",
  "block.minecraft.pale_oak_sapling": "Blyškiojo ąžuolo sodinukas",
  "block.minecraft.pale_oak_shelf": "Blyškiojo ąžuolo lentyna",
  "block.minecraft.pale_oak_sign": "Blyškiojo ąžuolo ženklas",
  "block.minecraft.pale_oak_slab": "Blyškiojo ąžuolo pusblokis",
  "block.minecraft.pale_oak_stairs": "Blyškiojo ąžuolo laiptai",
  "block.minecraft.pale_oak_trapdoor": "Blyškiojo ąžuolo liukas",
  "block.minecraft.pale_oak_wall_hanging_sign": "Blyškiojo ąžuolo kabantis ženklas",
  "block.minecraft.pale_oak_wall_sign": "Blyškiojo ąžuolo ženklas",
  "block.minecraft.pale_oak_wood": "Blyškiojo ąžuolo medis",
  "block.minecraft.pearlescent_froglight": "Purpurinė varlialempė",
  "block.minecraft.peony": "Bijūnas",
  "block.minecraft.petrified_oak_slab": "Suakmenėjęs ąžuolo pusblokis",
  "block.minecraft.piglin_head": "Piglino galva",
  "block.minecraft.piglin_wall_head": "Piglino galva ant sienos",
  "block.minecraft.pink_banner": "Rausva vėliava",
  "block.minecraft.pink_bed": "Rausva lova",
  "block.minecraft.pink_candle": "Rausva žvakė",
  "block.minecraft.pink_candle_cake": "Tortas su rausva žvake",
  "block.minecraft.pink_carpet": "Rausvas kilimas",
  "block.minecraft.pink_concrete": "Rausvas betonas",
  "block.minecraft.pink_concrete_powder": "Rausvas cementas",
  "block.minecraft.pink_glazed_terracotta": "Rausva glazūruota terakota",
  "block.minecraft.pink_petals": "Rausvi žiedlapiai",
  "block.minecraft.pink_shulker_box": "Rausva šulkerio dėžė",
  "block.minecraft.pink_stained_glass": "Rausvas dažytas stiklas",
  "block.minecraft.pink_stained_glass_pane": "Rausva dažyto stiklo plokštė",
  "block.minecraft.pink_terracotta": "Rausva terakota",
  "block.minecraft.pink_tulip": "Rausva tulpė",
  "block.minecraft.pink_wool": "Rausva vilna",
  "block.minecraft.piston": "Stūmoklis",
  "block.minecraft.piston_head": "Stūmoklio galvutė",
  "block.minecraft.pitcher_crop": "Ąsotenio pasėlis",
  "block.minecraft.pitcher_plant": "Ąsotenis",
  "block.minecraft.player_head": "Žaidėjo galva",
  "block.minecraft.player_head.named": "%s galva",
  "block.minecraft.player_wall_head": "Žaidėjo galva ant sienos",
  "block.minecraft.podzol": "Jaura",
  "block.minecraft.pointed_dripstone": "Aštrus varvakmenis",
  "block.minecraft.polished_andesite": "Šlifuotas andezitas",
  "block.minecraft.polished_andesite_slab": "Šlifuoto andezito pusblokis",
  "block.minecraft.polished_andesite_stairs": "Šlifuoto andezito laiptai",
  "block.minecraft.polished_basalt": "Šlifuotas bazaltas",
  "block.minecraft.polished_blackstone": "Šlifuotas juodakmenis",
  "block.minecraft.polished_blackstone_brick_slab": "Šlifuoto juodakmenio plytų pusblokis",
  "block.minecraft.polished_blackstone_brick_stairs": "Šlifuoto juodakmenio plytų laiptai",
  "block.minecraft.polished_blackstone_brick_wall": "Šlifuoto juodakmenio plytų siena",
  "block.minecraft.polished_blackstone_bricks": "Šlifuoto juodakmenio plytos",
  "block.minecraft.polished_blackstone_button": "Šlifuoto juodakmenio mygtukas",
  "block.minecraft.polished_blackstone_pressure_plate": "Šlifuoto juodakmenio slėgio plokštė",
  "block.minecraft.polished_blackstone_slab": "Šlifuoto juodakmenio pusblokis",
  "block.minecraft.polished_blackstone_stairs": "Šlifuoto juodakmenio laiptai",
  "block.minecraft.polished_blackstone_wall": "Šlifuoto juodakmenio siena",
  "block.minecraft.polished_deepslate": "Šlifuotas gilakmenis",
  "block.minecraft.polished_deepslate_slab": "Šlifuoto gilakmenio pusblokis",
  "block.minecraft.polished_deepslate_stairs": "Šlifuoto gilakmenio laiptai",
  "block.minecraft.polished_deepslate_wall": "Šlifuoto gilakmenio siena",
  "block.minecraft.polished_diorite": "Šlifuotas dioritas",
  "block.minecraft.polished_diorite_slab": "Šlifuoto diorito pusblokis",
  "block.minecraft.polished_diorite_stairs": "Šlifuoto diorito laiptai",
  "block.minecraft.polished_granite": "Šlifuotas granitas",
  "block.minecraft.polished_granite_slab": "Šlifuoto granito pusblokis",
  "block.minecraft.polished_granite_stairs": "Šlifuoto granito laiptai",
  "block.minecraft.polished_tuff": "Šlifuotas tufas",
  "block.minecraft.polished_tuff_slab": "Šlifuoto tufo pusblokis",
  "block.minecraft.polished_tuff_stairs": "Šlifuoto tufo laiptai",
  "block.minecraft.polished_tuff_wall": "Šlifuoto tufo siena",
  "block.minecraft.poppy": "Aguona",
  "block.minecraft.potatoes": "Bulvės",
  "block.minecraft.potted_acacia_sapling": "Pasodintas akacijos sodinukas",
  "block.minecraft.potted_allium": "Pasodintas česnakas",
  "block.minecraft.potted_azalea_bush": "Pasodinta azalija",
  "block.minecraft.potted_azure_bluet": "Pasodinta žydroji bajorė",
  "block.minecraft.potted_bamboo": "Pasodintas bambukas",
  "block.minecraft.potted_birch_sapling": "Pasodintas beržo sodinukas",
  "block.minecraft.potted_blue_orchid": "Pasodinta mėlynoji orchidėja",
  "block.minecraft.potted_brown_mushroom": "Pasodintas rudas grybas",
  "block.minecraft.potted_cactus": "Pasodintas kaktusas",
  "block.minecraft.potted_cherry_sapling": "Pasodintas vyšnios sodinukas",
  "block.minecraft.potted_closed_eyeblossom": "Pasodinta užsidariusi akižiedė",
  "block.minecraft.potted_cornflower": "Pasodinta rugiagėlė",
  "block.minecraft.potted_crimson_fungus": "Pasodintas raudonio grybas",
  "block.minecraft.potted_crimson_roots": "Pasodintos raudonio šaknys",
  "block.minecraft.potted_dandelion": "Pasodinta kiaulpienė",
  "block.minecraft.potted_dark_oak_sapling": "Pasodintas tamsiojo ąžuolo sodinukas",
  "block.minecraft.potted_dead_bush": "Pasodintas negyvas krūmas",
  "block.minecraft.potted_fern": "Pasodintas papartis",
  "block.minecraft.potted_flowering_azalea_bush": "Pasodinta žydinti azalija",
  "block.minecraft.potted_golden_dandelion": "Pasodinta auksinė kiaulpienė",
  "block.minecraft.potted_jungle_sapling": "Pasodintas džiunglių medžio sodinukas",
  "block.minecraft.potted_lily_of_the_valley": "Pasodinta pakalnutė",
  "block.minecraft.potted_mangrove_propagule": "Pasodintas mangrovės sodinukas",
  "block.minecraft.potted_oak_sapling": "Pasodintas ąžuolo sodinukas",
  "block.minecraft.potted_open_eyeblossom": "Pasodinta atsivėrusi akižiedė",
  "block.minecraft.potted_orange_tulip": "Pasodinta oranžinė tulpė",
  "block.minecraft.potted_oxeye_daisy": "Pasodinta ramunė",
  "block.minecraft.potted_pale_oak_sapling": "Pasodintas blyškiojo ąžuolo sodinukas",
  "block.minecraft.potted_pink_tulip": "Pasodinta rausva tulpė",
  "block.minecraft.potted_poppy": "Pasodinta aguona",
  "block.minecraft.potted_red_mushroom": "Pasodintas raudonas grybas",
  "block.minecraft.potted_red_tulip": "Pasodinta raudona tulpė",
  "block.minecraft.potted_spruce_sapling": "Pasodintas eglės sodinukas",
  "block.minecraft.potted_torchflower": "Pasodinta knipofija",
  "block.minecraft.potted_warped_fungus": "Pasodintas klaikusis grybas",
  "block.minecraft.potted_warped_roots": "Pasodintos klaikiosios šaknys",
  "block.minecraft.potted_white_tulip": "Pasodinta balta tulpė",
  "block.minecraft.potted_wither_rose": "Pasodinta witherio rožė",
  "block.minecraft.powder_snow": "Purus sniegas",
  "block.minecraft.powder_snow_cauldron": "Puraus sniego katilas",
  "block.minecraft.powered_rail": "Greitintuvas",
  "block.minecraft.prismarine": "Prizmarinas",
  "block.minecraft.prismarine_brick_slab": "Prismarino plytų pusblokis",
  "block.minecraft.prismarine_brick_stairs": "Prizmarino plytų laiptai",
  "block.minecraft.prismarine_bricks": "Prizmarino plytos",
  "block.minecraft.prismarine_slab": "Prizmarino pusblokis",
  "block.minecraft.prismarine_stairs": "Prizmarino laiptai",
  "block.minecraft.prismarine_wall": "Prismarino siena",
  "block.minecraft.pumpkin": "Moliūgas",
  "block.minecraft.pumpkin_stem": "Moliūgo stiebas",
  "block.minecraft.purple_banner": "Purpurinė vėliava",
  "block.minecraft.purple_bed": "Purpurinė lova",
  "block.minecraft.purple_candle": "Purpurinė žvakė",
  "block.minecraft.purple_candle_cake": "Tortas su purpurine žvake",
  "block.minecraft.purple_carpet": "Purpurinis kilimas",
  "block.minecraft.purple_concrete": "Purpurinis betonas",
  "block.minecraft.purple_concrete_powder": "Purpurinis cementas",
  "block.minecraft.purple_glazed_terracotta": "Purpurinė glazūruota terakota",
  "block.minecraft.purple_shulker_box": "Purpurinė šulkerio dėžė",
  "block.minecraft.purple_stained_glass": "Purpurinis dažytas stiklas",
  "block.minecraft.purple_stained_glass_pane": "Purpurinė dažyto stiklo plokštė",
  "block.minecraft.purple_terracotta": "Purpurinė terakota",
  "block.minecraft.purple_wool": "Purpurinė vilna",
  "block.minecraft.purpur_block": "Purpuro blokas",
  "block.minecraft.purpur_pillar": "Purpuro kolonos blokas",
  "block.minecraft.purpur_slab": "Purpuro pusblokis",
  "block.minecraft.purpur_stairs": "Purpuro laiptai",
  "block.minecraft.quartz_block": "Kvarco blokas",
  "block.minecraft.quartz_bricks": "Kvarco plytos",
  "block.minecraft.quartz_pillar": "Kvarco kolona",
  "block.minecraft.quartz_slab": "Kvarco pusblokis",
  "block.minecraft.quartz_stairs": "Kvarco laiptai",
  "block.minecraft.rail": "Bėgiai",
  "block.minecraft.raw_copper_block": "Neapdoroto vario blokas",
  "block.minecraft.raw_gold_block": "Neapdoroto aukso blokas",
  "block.minecraft.raw_iron_block": "Neapdorotos geležies blokas",
  "block.minecraft.red_banner": "Raudona vėliava",
  "block.minecraft.red_bed": "Raudona lova",
  "block.minecraft.red_candle": "Raudona žvakė",
  "block.minecraft.red_candle_cake": "Tortas su raudona žvake",
  "block.minecraft.red_carpet": "Raudonas kilimas",
  "block.minecraft.red_concrete": "Raudonas betonas",
  "block.minecraft.red_concrete_powder": "Raudonas cementas",
  "block.minecraft.red_glazed_terracotta": "Raudona glazūruota terakota",
  "block.minecraft.red_mushroom": "Raudonas grybas",
  "block.minecraft.red_mushroom_block": "Raudono grybo blokas",
  "block.minecraft.red_nether_brick_slab": "Raudonų Netherio plytų pusblokis",
  "block.minecraft.red_nether_brick_stairs": "Raudonų Netherio plytų laiptai",
  "block.minecraft.red_nether_brick_wall": "Raudonų Netherio plytų siena",
  "block.minecraft.red_nether_bricks": "Raudonosios Netherio plytos",
  "block.minecraft.red_sand": "Raudonasis smėlis",
  "block.minecraft.red_sandstone": "Raudonasis smiltainis",
  "block.minecraft.red_sandstone_slab": "Raudonojo smiltainio pusblokis",
  "block.minecraft.red_sandstone_stairs": "Raudonojo smiltainio laiptai",
  "block.minecraft.red_sandstone_wall": "Raudonojo smiltainio siena",
  "block.minecraft.red_shulker_box": "Raudona šulkerio dėžė",
  "block.minecraft.red_stained_glass": "Raudonas dažytas stiklas",
  "block.minecraft.red_stained_glass_pane": "Raudona dažyto stiklo plokštė",
  "block.minecraft.red_terracotta": "Raudona terakota",
  "block.minecraft.red_tulip": "Raudona tulpė",
  "block.minecraft.red_wool": "Raudona vilna",
  "block.minecraft.redstone_block": "Redstono blokas",
  "block.minecraft.redstone_lamp": "Redstoninė lempa",
  "block.minecraft.redstone_ore": "Redstono rūda",
  "block.minecraft.redstone_torch": "Redstono deglas",
  "block.minecraft.redstone_wall_torch": "Redstono deglas ant sienos",
  "block.minecraft.redstone_wire": "Redstono laidas",
  "block.minecraft.reinforced_deepslate": "Sustiprintas gilakmenis",
  "block.minecraft.repeater": "Redstono kartotuvas",
  "block.minecraft.repeating_command_block": "Besikartojantis komandos blokas",
  "block.minecraft.resin_block": "Sakų blokas",
  "block.minecraft.resin_brick_slab": "Sakų plytų pusblokis",
  "block.minecraft.resin_brick_stairs": "Sakų plytų laiptai",
  "block.minecraft.resin_brick_wall": "Sakų plytų siena",
  "block.minecraft.resin_bricks": "Sakų plytos",
  "block.minecraft.resin_clump": "Sakų gumulas",
  "block.minecraft.respawn_anchor": "Prisikėlimo inkaras",
  "block.minecraft.rooted_dirt": "Įsišaknijusi žemė",
  "block.minecraft.rose_bush": "Rožių krūmas",
  "block.minecraft.sand": "Smėlis",
  "block.minecraft.sandstone": "Smiltainis",
  "block.minecraft.sandstone_slab": "Smiltainio pusblokis",
  "block.minecraft.sandstone_stairs": "Smiltainio laiptai",
  "block.minecraft.sandstone_wall": "Smiltainio siena",
  "block.minecraft.scaffolding": "Pastoliai",
  "block.minecraft.sculk": "Sculkas",
  "block.minecraft.sculk_catalyst": "Sculko katalizatorius",
  "block.minecraft.sculk_sensor": "Sculko sensorius",
  "block.minecraft.sculk_shrieker": "Sculko rėksnys",
  "block.minecraft.sculk_vein": "Sculko gysla",
  "block.minecraft.sea_lantern": "Jūros žibintas",
  "block.minecraft.sea_pickle": "Jūros agurkas",
  "block.minecraft.seagrass": "Jūržolė",
  "block.minecraft.set_spawn": "Nustatytas naujas prisikėlimo taškas",
  "block.minecraft.short_dry_grass": "Trumpa sausa žolė",
  "block.minecraft.short_grass": "Trumpa žolė",
  "block.minecraft.shroomlight": "Šviesagrybis",
  "block.minecraft.shulker_box": "Šulkerio dėžė",
  "block.minecraft.skeleton_skull": "Skeleto kaukolė",
  "block.minecraft.skeleton_wall_skull": "Skeleto kaukolė ant sienos",
  "block.minecraft.slime_block": "Gleivių blokas",
  "block.minecraft.small_amethyst_bud": "Mažas ametisto kristalas",
  "block.minecraft.small_dripleaf": "Mažas varvalapis",
  "block.minecraft.smithing_table": "Kalvio stalas",
  "block.minecraft.smoker": "Rūkykla",
  "block.minecraft.smooth_basalt": "Lygus bazaltas",
  "block.minecraft.smooth_quartz": "Lygus kvarco blokas",
  "block.minecraft.smooth_quartz_slab": "Lygaus kvarco pusblokis",
  "block.minecraft.smooth_quartz_stairs": "Lygaus kvarco laiptai",
  "block.minecraft.smooth_red_sandstone": "Lygus raudonasis smiltainis",
  "block.minecraft.smooth_red_sandstone_slab": "Lygaus raudonojo smiltainio pusblokis",
  "block.minecraft.smooth_red_sandstone_stairs": "Lygaus raudonojo smiltainio laiptai",
  "block.minecraft.smooth_sandstone": "Lygus smiltainis",
  "block.minecraft.smooth_sandstone_slab": "Lygaus smiltainio pusblokis",
  "block.minecraft.smooth_sandstone_stairs": "Lygaus smiltainio laiptai",
  "block.minecraft.smooth_stone": "Lygus akmuo",
  "block.minecraft.smooth_stone_slab": "Lygaus akmens pusblokis",
  "block.minecraft.sniffer_egg": "Šniukštinėtojo kiaušinis",
  "block.minecraft.snow": "Sniegas",
  "block.minecraft.snow_block": "Sniego blokas",
  "block.minecraft.soul_campfire": "Sielų laužas",
  "block.minecraft.soul_fire": "Sielų ugnis",
  "block.minecraft.soul_lantern": "Sielų žibintas",
  "block.minecraft.soul_sand": "Sielų smėlis",
  "block.minecraft.soul_soil": "Sielų dirva",
  "block.minecraft.soul_torch": "Sielų deglas",
  "block.minecraft.soul_wall_torch": "Sielų sienos deglas",
  "block.minecraft.spawn.not_valid": "Jūs neturite namų lovos ar pakrauto prisikėlimo inkaro arba jie buvo sunaikinti",
  "block.minecraft.spawner": "Monstrų generatorius",
  "block.minecraft.spawner.desc1": "Panaudoti padaro kiaušinį:",
  "block.minecraft.spawner.desc2": "Nustato padaro tipą",
  "block.minecraft.sponge": "Kempinė",
  "block.minecraft.spore_blossom": "Sporų žiedas",
  "block.minecraft.spruce_button": "Eglės mygtukas",
  "block.minecraft.spruce_door": "Eglės durys",
  "block.minecraft.spruce_fence": "Eglės tvora",
  "block.minecraft.spruce_fence_gate": "Eglės varteliai",
  "block.minecraft.spruce_hanging_sign": "Eglės kabantis ženklas",
  "block.minecraft.spruce_leaves": "Eglės spygliai",
  "block.minecraft.spruce_log": "Eglės rąstas",
  "block.minecraft.spruce_planks": "Eglės lentos",
  "block.minecraft.spruce_pressure_plate": "Eglinė slėgio plokštė",
  "block.minecraft.spruce_sapling": "Eglės sodinukas",
  "block.minecraft.spruce_shelf": "Eglės lentyna",
  "block.minecraft.spruce_sign": "Eglės ženklas",
  "block.minecraft.spruce_slab": "Eglės pusblokis",
  "block.minecraft.spruce_stairs": "Eglės laiptai",
  "block.minecraft.spruce_trapdoor": "Eglės liukas",
  "block.minecraft.spruce_wall_hanging_sign": "Eglės sienos kabantis ženklas",
  "block.minecraft.spruce_wall_sign": "Eglės sienos ženklas",
  "block.minecraft.spruce_wood": "Eglės medis",
  "block.minecraft.sticky_piston": "Lipnus stūmoklis",
  "block.minecraft.stone": "Akmuo",
  "block.minecraft.stone_brick_slab": "Akmens plytų pusblokis",
  "block.minecraft.stone_brick_stairs": "Akmens plytų laiptai",
  "block.minecraft.stone_brick_wall": "Akmens plytų siena",
  "block.minecraft.stone_bricks": "Akmens plytos",
  "block.minecraft.stone_button": "Akmens mygtukas",
  "block.minecraft.stone_pressure_plate": "Akmeninė slėgio plokštė",
  "block.minecraft.stone_slab": "Akmens pusblokis",
  "block.minecraft.stone_stairs": "Akmens laiptai",
  "block.minecraft.stonecutter": "Akmens pjaustyklė",
  "block.minecraft.stripped_acacia_log": "Nuluptas akacijos rąstas",
  "block.minecraft.stripped_acacia_wood": "Nuluptas akacijos medis",
  "block.minecraft.stripped_bamboo_block": "Nuluptas bambuko blokas",
  "block.minecraft.stripped_birch_log": "Nuluptas beržo rąstas",
  "block.minecraft.stripped_birch_wood": "Nuluptas beržo medis",
  "block.minecraft.stripped_cherry_log": "Nuluptas vyšnios rąstas",
  "block.minecraft.stripped_cherry_wood": "Nuluptas vyšnios medis",
  "block.minecraft.stripped_crimson_hyphae": "Nulupti raudonio hifai",
  "block.minecraft.stripped_crimson_stem": "Nuluptas raudonio stiebas",
  "block.minecraft.stripped_dark_oak_log": "Nuluptas tamsiojo ąžuolo rąstas",
  "block.minecraft.stripped_dark_oak_wood": "Nuluptas tamsiojo ąžuolo medis",
  "block.minecraft.stripped_jungle_log": "Nuluptas džiunglių medžio rąstas",
  "block.minecraft.stripped_jungle_wood": "Nuluptas džiunglių medis",
  "block.minecraft.stripped_mangrove_log": "Nuluptas mangrovės rąstas",
  "block.minecraft.stripped_mangrove_wood": "Nuluptas mangrovės medis",
  "block.minecraft.stripped_oak_log": "Nuluptas ąžuolo rąstas",
  "block.minecraft.stripped_oak_wood": "Nuluptas ąžuolo medis",
  "block.minecraft.stripped_pale_oak_log": "Nuluptas blyškiojo ąžuolo rąstas",
  "block.minecraft.stripped_pale_oak_wood": "Nuluptas blyškiojo ąžuolo medis",
  "block.minecraft.stripped_spruce_log": "Nuluptas eglės rąstas",
  "block.minecraft.stripped_spruce_wood": "Nuluptas eglės medis",
  "block.minecraft.stripped_warped_hyphae": "Nulupti klaikieji hifai",
  "block.minecraft.stripped_warped_stem": "Nuluptas klaikusis stiebas",
  "block.minecraft.structure_block": "Struktūros blokas",
  "block.minecraft.structure_void": "Struktūrinė tuštuma",
  "block.minecraft.sugar_cane": "Cukranendrė",
  "block.minecraft.sunflower": "Saulėgrąža",
  "block.minecraft.suspicious_gravel": "Įtartinas žvyras",
  "block.minecraft.suspicious_sand": "Įtartinas smėlis",
  "block.minecraft.sweet_berry_bush": "Saldžiųjų uogų krūmas",
  "block.minecraft.tall_dry_grass": "Aukšta sausa žolė",
  "block.minecraft.tall_grass": "Aukšta žolė",
  "block.minecraft.tall_seagrass": "Aukšta jūržolė",
  "block.minecraft.target": "Taikinys",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Testo blokas",
  "block.minecraft.test_instance_block": "Testavimo blokas",
  "block.minecraft.tinted_glass": "Tamsintas stiklas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT sprogimai išjungti",
  "block.minecraft.torch": "Deglas",
  "block.minecraft.torchflower": "Knipofija",
  "block.minecraft.torchflower_crop": "Knipofijos stiebas",
  "block.minecraft.trapped_chest": "Skrynia-spąstai",
  "block.minecraft.trial_spawner": "Išbandymo generatorius",
  "block.minecraft.tripwire": "Viela",
  "block.minecraft.tripwire_hook": "Vielos kablys",
  "block.minecraft.tube_coral": "Vamzdinis koralas",
  "block.minecraft.tube_coral_block": "Vamzdinis koralo blokas",
  "block.minecraft.tube_coral_fan": "Vamzdinis koralas vėduoklė",
  "block.minecraft.tube_coral_wall_fan": "Vamzdinis sienos koralas vėduoklė",
  "block.minecraft.tuff": "Tufas",
  "block.minecraft.tuff_brick_slab": "Tufo plytų pusblokis",
  "block.minecraft.tuff_brick_stairs": "Tufo plytų laiptai",
  "block.minecraft.tuff_brick_wall": "Tufo plytų siena",
  "block.minecraft.tuff_bricks": "Tufo plytos",
  "block.minecraft.tuff_slab": "Tufo pusblokis",
  "block.minecraft.tuff_stairs": "Tufo laiptai",
  "block.minecraft.tuff_wall": "Tufo siena",
  "block.minecraft.turtle_egg": "Vėžlio kiaušinis",
  "block.minecraft.twisting_vines": "Klaikieji vijokliai",
  "block.minecraft.twisting_vines_plant": "Klaikiųjų vijoklių augalas",
  "block.minecraft.vault": "Saugykla",
  "block.minecraft.verdant_froglight": "Žalia varlialempė",
  "block.minecraft.vine": "Vijokliai",
  "block.minecraft.void_air": "Tuštumos oras",
  "block.minecraft.wall_torch": "Deglas ant sienos",
  "block.minecraft.warped_button": "Klaikusis mygtukas",
  "block.minecraft.warped_door": "Klaikiosios durys",
  "block.minecraft.warped_fence": "Klaikioji tvora",
  "block.minecraft.warped_fence_gate": "Klaikieji vartai",
  "block.minecraft.warped_fungus": "Klaikusis grybas",
  "block.minecraft.warped_hanging_sign": "Klaikusis kabantis ženklas",
  "block.minecraft.warped_hyphae": "Klaikieji hifai",
  "block.minecraft.warped_nylium": "Klaikioji grybiena",
  "block.minecraft.warped_planks": "Klaikiosios lentos",
  "block.minecraft.warped_pressure_plate": "Klaikioji slėgio plokštė",
  "block.minecraft.warped_roots": "Klaikiosios šaknys",
  "block.minecraft.warped_shelf": "Klaikioji lentyna",
  "block.minecraft.warped_sign": "Klaikusis ženklas",
  "block.minecraft.warped_slab": "Klaikusis pusblokis",
  "block.minecraft.warped_stairs": "Klaikieji laiptai",
  "block.minecraft.warped_stem": "Klaikusis stiebas",
  "block.minecraft.warped_trapdoor": "Klaikusis liukas",
  "block.minecraft.warped_wall_hanging_sign": "Klaikusis sienos kabantis ženklas",
  "block.minecraft.warped_wall_sign": "Klaikusis sienos ženklas",
  "block.minecraft.warped_wart_block": "Klaikusis gumbo blokas",
  "block.minecraft.water": "Vanduo",
  "block.minecraft.water_cauldron": "Vandens katilas",
  "block.minecraft.waxed_chiseled_copper": "Vaškuotas raižytas varis",
  "block.minecraft.waxed_copper_bars": "Vaškuotos varinės grotos",
  "block.minecraft.waxed_copper_block": "Vaškuoto vario blokas",
  "block.minecraft.waxed_copper_bulb": "Vaškuota varinė lemputė",
  "block.minecraft.waxed_copper_chain": "Vaškuota varinė grandinė",
  "block.minecraft.waxed_copper_chest": "Vaškuota varinė skrynia",
  "block.minecraft.waxed_copper_door": "Vaškuotos varinės durys",
  "block.minecraft.waxed_copper_golem_statue": "Vaškuota varinio golemo statula",
  "block.minecraft.waxed_copper_grate": "Vaškuotos varinės grotelės",
  "block.minecraft.waxed_copper_lantern": "Vaškuotas varinis žibintas",
  "block.minecraft.waxed_copper_trapdoor": "Vaškuotas varinis liukas",
  "block.minecraft.waxed_cut_copper": "Vaškuoto pjauto vario blokas",
  "block.minecraft.waxed_cut_copper_slab": "Vaškuoto pjauto vario pusblokis",
  "block.minecraft.waxed_cut_copper_stairs": "Vaškuoto pjauto vario laiptai",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vaškuotas paveiktas raižytas varis",
  "block.minecraft.waxed_exposed_copper": "Vaškuoto paveikto vario blokas",
  "block.minecraft.waxed_exposed_copper_bars": "Vaškuotos paveiktos varinės grotos",
  "block.minecraft.waxed_exposed_copper_bulb": "Vaškuota paveikta varinė lemputė",
  "block.minecraft.waxed_exposed_copper_chain": "Vaškuota paveikta varinė grandinė",
  "block.minecraft.waxed_exposed_copper_chest": "Vaškuota paveikta varinė skrynia",
  "block.minecraft.waxed_exposed_copper_door": "Vaškuotos paveiktos varinės durys",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vaškuota paveitka varinio golemo statula",
  "block.minecraft.waxed_exposed_copper_grate": "Vaškuotos paveiktos varinės grotelės",
  "block.minecraft.waxed_exposed_copper_lantern": "Vaškuotas paveiktas varinis žibintas",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vaškuotas paveiktas varinis liukas",
  "block.minecraft.waxed_exposed_cut_copper": "Vaškuoto paveikto pjauto vario blokas",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vaškuoto paveikto pjauto vario pusblokis",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vaškuoto paveikto pjauto vario laiptai",
  "block.minecraft.waxed_exposed_lightning_rod": "Vaškuotas oksiduotas žaibolaidis",
  "block.minecraft.waxed_lightning_rod": "Vaškuotas žaibolaidis",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vaškuotas oksiduotas raižytas varis",
  "block.minecraft.waxed_oxidized_copper": "Vaškuotas oksiduotas varis",
  "block.minecraft.waxed_oxidized_copper_bars": "Vaškuotos oksiduotos varinės grotos",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vaškuota oksiduota varinė lemputė",
  "block.minecraft.waxed_oxidized_copper_chain": "Vaškuota oksiduota varinė grandinė",
  "block.minecraft.waxed_oxidized_copper_chest": "Vaškuota oksiduota varinė skrynia",
  "block.minecraft.waxed_oxidized_copper_door": "Vaškuotos oksiduotos varinės durys",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vaškuota oksiduota varinio golemo statula",
  "block.minecraft.waxed_oxidized_copper_grate": "Vaškuotos oksiduotos varinės grotelės",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vaškuotas oksiduotas varinis žibintas",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vaškuotas oksiduotas varinis liukas",
  "block.minecraft.waxed_oxidized_cut_copper": "Vaškuotas oksiduotas pjautas varis",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vaškuoto oksiduoto pjauto vario pusblokis",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vaškuoto oksiduoto pjauto vario laiptai",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vaškuotas oksiduotas žaibolaidis",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vaškuotas stipriai paveiktas raižytas varis",
  "block.minecraft.waxed_weathered_copper": "Vaškuoto stipriai paveikto vario blokas",
  "block.minecraft.waxed_weathered_copper_bars": "Vaškuotos stipriai paveiktos varinės grotos",
  "block.minecraft.waxed_weathered_copper_bulb": "Vaškuota stipriai paveikta varinė lemputė",
  "block.minecraft.waxed_weathered_copper_chain": "Vaškuota stipriai paveikta varinė grandinė",
  "block.minecraft.waxed_weathered_copper_chest": "Vaškuota stipriai paveikta varinė skrynia",
  "block.minecraft.waxed_weathered_copper_door": "Vaškuotos stipriai paveiktos varinės durys",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vaškuota stipriai paveikta varinio golemo statula",
  "block.minecraft.waxed_weathered_copper_grate": "Vaškuotos stipriai paveiktos varinės grotelės",
  "block.minecraft.waxed_weathered_copper_lantern": "Vaškuotas stipriai paveiktas varinis žibintas",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vaškuotas stipriai paveiktas varinis liukas",
  "block.minecraft.waxed_weathered_cut_copper": "Vaškuoto stipriai paveikto pjauto vario blokas",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vaškuoto stipriai paveikto pjauto vario pusblokis",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vaškuoto stipriai paveikto pjauto vario laiptai",
  "block.minecraft.waxed_weathered_lightning_rod": "Vaškuotas stipriai paveiktas žaibolaidis",
  "block.minecraft.weathered_chiseled_copper": "Stipriai paveiktas raižytas varis",
  "block.minecraft.weathered_copper": "Stipriai paveiktas vario blokas",
  "block.minecraft.weathered_copper_bars": "Stipriai paveiktos varinės grotos",
  "block.minecraft.weathered_copper_bulb": "Stipriai paveikta varinė lemputė",
  "block.minecraft.weathered_copper_chain": "Stipriai paveikta varinė grandinė",
  "block.minecraft.weathered_copper_chest": "Stipriai paveikta varinė skrynia",
  "block.minecraft.weathered_copper_door": "Stipriai paveiktos varinės durys",
  "block.minecraft.weathered_copper_golem_statue": "Stipriai paveikta varinio golemo statula",
  "block.minecraft.weathered_copper_grate": "Stipriai paveiktos varinės grotelės",
  "block.minecraft.weathered_copper_lantern": "Stipriai paveiktas varinis žibintas",
  "block.minecraft.weathered_copper_trapdoor": "Stipriai paveiktas varinis liukas",
  "block.minecraft.weathered_cut_copper": "Stipriai paveiktas pjauto vario blokas",
  "block.minecraft.weathered_cut_copper_slab": "Stipriai paveikto pjauto vario pusblokis",
  "block.minecraft.weathered_cut_copper_stairs": "Stipriai paveikto pjauto vario laiptai",
  "block.minecraft.weathered_lightning_rod": "Stipriai paveiktas žaibolaidis",
  "block.minecraft.weeping_vines": "Raudonio vijokliai",
  "block.minecraft.weeping_vines_plant": "Raudonio vijoklių augalas",
  "block.minecraft.wet_sponge": "Šlapia kempinė",
  "block.minecraft.wheat": "Kviečių augalai",
  "block.minecraft.white_banner": "Balta vėliava",
  "block.minecraft.white_bed": "Balta lova",
  "block.minecraft.white_candle": "Balta žvakė",
  "block.minecraft.white_candle_cake": "Tortas su balta žvake",
  "block.minecraft.white_carpet": "Baltas kilimas",
  "block.minecraft.white_concrete": "Baltas betonas",
  "block.minecraft.white_concrete_powder": "Baltas cementas",
  "block.minecraft.white_glazed_terracotta": "Balta glazūruota terakota",
  "block.minecraft.white_shulker_box": "Balta šulkerio dėžė",
  "block.minecraft.white_stained_glass": "Baltas dažytas stiklas",
  "block.minecraft.white_stained_glass_pane": "Balta dažyto stiklo plokštė",
  "block.minecraft.white_terracotta": "Balta terakota",
  "block.minecraft.white_tulip": "Balta tulpė",
  "block.minecraft.white_wool": "Balta vilna",
  "block.minecraft.wildflowers": "Gvaizdūnės",
  "block.minecraft.wither_rose": "Witherio rožė",
  "block.minecraft.wither_skeleton_skull": "Wither skeleto kaukolė",
  "block.minecraft.wither_skeleton_wall_skull": "Wither skeleto kaukolė ant sienos",
  "block.minecraft.yellow_banner": "Geltona vėliava",
  "block.minecraft.yellow_bed": "Geltona lova",
  "block.minecraft.yellow_candle": "Geltona žvakė",
  "block.minecraft.yellow_candle_cake": "Tortas su geltona žvake",
  "block.minecraft.yellow_carpet": "Geltonas kilimas",
  "block.minecraft.yellow_concrete": "Geltonas betonas",
  "block.minecraft.yellow_concrete_powder": "Geltonas cementas",
  "block.minecraft.yellow_glazed_terracotta": "Geltona glazūruota terakota",
  "block.minecraft.yellow_shulker_box": "Geltona šulkerio dėžė",
  "block.minecraft.yellow_stained_glass": "Geltonas dažytas stiklas",
  "block.minecraft.yellow_stained_glass_pane": "Geltona dažyto stiklo plokštė",
  "block.minecraft.yellow_terracotta": "Geltona terakota",
  "block.minecraft.yellow_wool": "Geltona vilna",
  "block.minecraft.zombie_head": "Zombio galva",
  "block.minecraft.zombie_wall_head": "Zombio galva ant sienos",
  "item.minecraft.acacia_boat": "Akacijos valtis",
  "item.minecraft.acacia_chest_boat": "Akacijos valtis su skrynia",
  "item.minecraft.allay_spawn_egg": "Suformuoto alėjaus kiaušinis",
  "item.minecraft.amethyst_shard": "Ametisto skeveldra",
  "item.minecraft.angler_pottery_shard": "Žvejo keramikos šukė",
  "item.minecraft.angler_pottery_sherd": "Žvejo keramikos šukė",
  "item.minecraft.apple": "Obuolys",
  "item.minecraft.archer_pottery_shard": "Lankininko keramikos šukė",
  "item.minecraft.archer_pottery_sherd": "Lankininko keramikos šukė",
  "item.minecraft.armadillo_scute": "Šarvuočio skydelis",
  "item.minecraft.armadillo_spawn_egg": "Suformuoto šarvuočio kiaušinis",
  "item.minecraft.armor_stand": "Šarvų stovas",
  "item.minecraft.arms_up_pottery_shard": "Čempiono keramikos šukė",
  "item.minecraft.arms_up_pottery_sherd": "Čempiono keramikos šukė",
  "item.minecraft.arrow": "Strėlė",
  "item.minecraft.axolotl_bucket": "Aksolotlio kibiras",
  "item.minecraft.axolotl_spawn_egg": "Suformuoto aksolotlio kiaušinis",
  "item.minecraft.baked_potato": "Kepta bulvė",
  "item.minecraft.bamboo_chest_raft": "Bambuko plaustas su skrynia",
  "item.minecraft.bamboo_raft": "Bambuko plaustas",
  "item.minecraft.bat_spawn_egg": "Suformuoto šikšnosparnio kiaušinis",
  "item.minecraft.bee_spawn_egg": "Suformuotos bitės kiaušinis",
  "item.minecraft.beef": "Žalia jautiena",
  "item.minecraft.beetroot": "Burokėlis",
  "item.minecraft.beetroot_seeds": "Burokėlių sėklos",
  "item.minecraft.beetroot_soup": "Barščiai",
  "item.minecraft.birch_boat": "Beržo valtis",
  "item.minecraft.birch_chest_boat": "Beržo valtis su skrynia",
  "item.minecraft.black_bundle": "Juodas ryšulys",
  "item.minecraft.black_dye": "Juodi dažai",
  "item.minecraft.black_harness": "Juodi pakinktai",
  "item.minecraft.blade_pottery_shard": "Ašmens keramikos šukė",
  "item.minecraft.blade_pottery_sherd": "Ašmens keramikos šukė",
  "item.minecraft.blaze_powder": "Liepsnos pudra",
  "item.minecraft.blaze_rod": "Liepsnos strypas",
  "item.minecraft.blaze_spawn_egg": "Suformuotos liepsnos kiaušinis",
  "item.minecraft.blue_bundle": "Mėlynas ryšulys",
  "item.minecraft.blue_dye": "Mėlyni dažai",
  "item.minecraft.blue_egg": "Mėlynas kiaušinis",
  "item.minecraft.blue_harness": "Mėlyni pakinktai",
  "item.minecraft.bogged_spawn_egg": "Suformuoto klampinėtojo kiaušinis",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Žaibiškų šarvų puošmuo",
  "item.minecraft.bone": "Kaulas",
  "item.minecraft.bone_meal": "Kaulų miltai",
  "item.minecraft.book": "Knyga",
  "item.minecraft.bordure_indented_banner_pattern": "Vingiuoto rėmelio vėliavos raštas",
  "item.minecraft.bow": "Lankas",
  "item.minecraft.bowl": "Dubuo",
  "item.minecraft.bread": "Duona",
  "item.minecraft.breeze_rod": "Gūsio strypas",
  "item.minecraft.breeze_spawn_egg": "Suformuoto vėjelio kiaušinis",
  "item.minecraft.brewer_pottery_shard": "Eliksyrų gamintojo keramikos šukė",
  "item.minecraft.brewer_pottery_sherd": "Eliksyrų gamintojo keramikos šukė",
  "item.minecraft.brewing_stand": "Eliksyrų stovas",
  "item.minecraft.brick": "Plyta",
  "item.minecraft.brown_bundle": "Rudas ryšulys",
  "item.minecraft.brown_dye": "Rudi dažai",
  "item.minecraft.brown_egg": "Rudas kiaušinis",
  "item.minecraft.brown_harness": "Rudi pakinktai",
  "item.minecraft.brush": "Teptukas",
  "item.minecraft.bucket": "Kibiras",
  "item.minecraft.bundle": "Ryšulys",
  "item.minecraft.bundle.empty": "Tuščias",
  "item.minecraft.bundle.empty.description": "Gali laikyti skirtingas rūšis daiktų",
  "item.minecraft.bundle.full": "Pilnas",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Ugnies keramikos šukė",
  "item.minecraft.burn_pottery_sherd": "Ugnies keramikos šukė",
  "item.minecraft.camel_husk_spawn_egg": "Suformuoto sudžiūvėlio kupranugario kiaušinis",
  "item.minecraft.camel_spawn_egg": "Suformuoto kupranugario kiaušinis",
  "item.minecraft.carrot": "Morka",
  "item.minecraft.carrot_on_a_stick": "Morka ant pagaliuko",
  "item.minecraft.cat_spawn_egg": "Suformuotos katės kiaušinis",
  "item.minecraft.cauldron": "Katilas",
  "item.minecraft.cave_spider_spawn_egg": "Suformuoto urvinio voro kiaušinis",
  "item.minecraft.chainmail_boots": "Grandininiai batai",
  "item.minecraft.chainmail_chestplate": "Grandininis antkrūtinis",
  "item.minecraft.chainmail_helmet": "Grandininis šalmas",
  "item.minecraft.chainmail_leggings": "Grandininės kelnės",
  "item.minecraft.charcoal": "Medžio anglis",
  "item.minecraft.cherry_boat": "Vyšnios valtis",
  "item.minecraft.cherry_chest_boat": "Vyšnios valtis su skrynia",
  "item.minecraft.chest_minecart": "Vagonėlis su skrynia",
  "item.minecraft.chicken": "Žalia vištiena",
  "item.minecraft.chicken_spawn_egg": "Suformuotos vištos kiaušinis",
  "item.minecraft.chorus_fruit": "Koruso vaisius",
  "item.minecraft.clay_ball": "Molio kamuoliukas",
  "item.minecraft.clock": "Laikrodis",
  "item.minecraft.coal": "Anglis",
  "item.minecraft.coast_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Pakrantės šarvų puošmuo",
  "item.minecraft.cocoa_beans": "Kakavos pupelės",
  "item.minecraft.cod": "Žalia menkė",
  "item.minecraft.cod_bucket": "Menkė kibire",
  "item.minecraft.cod_spawn_egg": "Suformuotos menkės kiaušinis",
  "item.minecraft.command_block_minecart": "Vagonėlis su komandos bloku",
  "item.minecraft.compass": "Kompasas",
  "item.minecraft.cooked_beef": "Kepsnys",
  "item.minecraft.cooked_chicken": "Kepta vištiena",
  "item.minecraft.cooked_cod": "Kepta menkė",
  "item.minecraft.cooked_mutton": "Kepta aviena",
  "item.minecraft.cooked_porkchop": "Kepta kiauliena",
  "item.minecraft.cooked_rabbit": "Keptas triušis",
  "item.minecraft.cooked_salmon": "Kepta lašiša",
  "item.minecraft.cookie": "Sausainis",
  "item.minecraft.copper_axe": "Varinis kirvis",
  "item.minecraft.copper_boots": "Variniai batai",
  "item.minecraft.copper_chestplate": "Varinis antkrūtinis",
  "item.minecraft.copper_golem_spawn_egg": "Suformuoto varinio golemo kiaušinis",
  "item.minecraft.copper_helmet": "Varinis šalmas",
  "item.minecraft.copper_hoe": "Varinis kaplys",
  "item.minecraft.copper_horse_armor": "Variniai arklio šarvai",
  "item.minecraft.copper_ingot": "Vario liejinys",
  "item.minecraft.copper_leggings": "Varinės kelnės",
  "item.minecraft.copper_nautilus_armor": "Variniai nautilo šarvai",
  "item.minecraft.copper_nugget": "Vario grynuolis",
  "item.minecraft.copper_pickaxe": "Varinis kirtiklis",
  "item.minecraft.copper_shovel": "Varinis kastuvas",
  "item.minecraft.copper_spear": "Varinė ietis",
  "item.minecraft.copper_sword": "Varinis kardas",
  "item.minecraft.cow_spawn_egg": "Suformuotos karvės kiaušinis",
  "item.minecraft.creaking_spawn_egg": "Suformuoto girgždžio kiaušinis",
  "item.minecraft.creeper_banner_pattern": "Vėliavos raštas",
  "item.minecraft.creeper_banner_pattern.desc": "Kryperio veidas",
  "item.minecraft.creeper_banner_pattern.new": "Kryperio veido vėliavos raštas",
  "item.minecraft.creeper_spawn_egg": "Suformuoto kryperio kiaušinis",
  "item.minecraft.crossbow": "Arbaletas",
  "item.minecraft.crossbow.projectile": "Šovinys:",
  "item.minecraft.crossbow.projectile.multiple": "Šovinys: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Šovinys: %s",
  "item.minecraft.cyan_bundle": "Turkio ryšulys",
  "item.minecraft.cyan_dye": "Tamsiai žydri dažai",
  "item.minecraft.cyan_harness": "Turkio pakinktai",
  "item.minecraft.danger_pottery_shard": "Pavojaus keramikos šukė",
  "item.minecraft.danger_pottery_sherd": "Pavojaus keramikos šukė",
  "item.minecraft.dark_oak_boat": "Tamsiojo ąžuolo valtis",
  "item.minecraft.dark_oak_chest_boat": "Tamsiojo ąžuolo valtis su skrynia",
  "item.minecraft.debug_stick": "Derinimo pagaliukas",
  "item.minecraft.debug_stick.empty": "%s neturi savybių",
  "item.minecraft.debug_stick.select": "pasirinktas \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "„%s” į %s",
  "item.minecraft.diamond": "Deimantas",
  "item.minecraft.diamond_axe": "Deimantinis kirvis",
  "item.minecraft.diamond_boots": "Deimantiniai batai",
  "item.minecraft.diamond_chestplate": "Deimantinis antkrūtinis",
  "item.minecraft.diamond_helmet": "Deimantinis šalmas",
  "item.minecraft.diamond_hoe": "Deimantinis kaplys",
  "item.minecraft.diamond_horse_armor": "Deimantiniai arklio šarvai",
  "item.minecraft.diamond_leggings": "Deimantinės kelnės",
  "item.minecraft.diamond_nautilus_armor": "Deimantiniai nautilo šarvai",
  "item.minecraft.diamond_pickaxe": "Deimantinis kirtiklis",
  "item.minecraft.diamond_shovel": "Deimantinis kastuvas",
  "item.minecraft.diamond_spear": "Deimantinė ietis",
  "item.minecraft.diamond_sword": "Deimantinis kardas",
  "item.minecraft.disc_fragment_5": "Disko fragmentas",
  "item.minecraft.disc_fragment_5.desc": "Muzikos diskas - 5",
  "item.minecraft.dolphin_spawn_egg": "Suformuoto delfino kiaušinis",
  "item.minecraft.donkey_spawn_egg": "Suformuoto asilo kiaušinis",
  "item.minecraft.dragon_breath": "Drakonės dvelksmas",
  "item.minecraft.dried_kelp": "Džiovinti rudadumbliai",
  "item.minecraft.drowned_spawn_egg": "Suformuoto skenduolio kiaušinis",
  "item.minecraft.dune_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Kopų šarvų puošmuo",
  "item.minecraft.echo_shard": "Aido šukė",
  "item.minecraft.egg": "Kiaušinis",
  "item.minecraft.elder_guardian_spawn_egg": "Suformuoto didžiojo gelmių sargo kiaušinis",
  "item.minecraft.elytra": "Sparnai",
  "item.minecraft.emerald": "Smaragdas",
  "item.minecraft.enchanted_book": "Užkerėta knyga",
  "item.minecraft.enchanted_golden_apple": "Užkerėtas auksinis obuolys",
  "item.minecraft.end_crystal": "Endo kristalas",
  "item.minecraft.ender_dragon_spawn_egg": "Suformuotos enderio drakonės kiaušinis",
  "item.minecraft.ender_eye": "Enderio akis",
  "item.minecraft.ender_pearl": "Enderio perlas",
  "item.minecraft.enderman_spawn_egg": "Suformuoto endermeno kiaušinis",
  "item.minecraft.endermite_spawn_egg": "Suformuoto endermito kiaušinis",
  "item.minecraft.evoker_spawn_egg": "Suformuoto šamano kiaušinis",
  "item.minecraft.experience_bottle": "Patirties buteliukas",
  "item.minecraft.explorer_pottery_shard": "Tyrinėtojo keramikos šukė",
  "item.minecraft.explorer_pottery_sherd": "Tyrinėtojo keramikos šukė",
  "item.minecraft.eye_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Akies šarvų puošmuo",
  "item.minecraft.feather": "Plunksna",
  "item.minecraft.fermented_spider_eye": "Rauginta voro akis",
  "item.minecraft.field_masoned_banner_pattern": "Plytų fono vėliavos raštas",
  "item.minecraft.filled_map": "Žemėlapis",
  "item.minecraft.fire_charge": "Ugnies kamuolys",
  "item.minecraft.firework_rocket": "Fejerverkas",
  "item.minecraft.firework_rocket.flight": "Skrydžio trukmė:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fejerverko žvaigždė",
  "item.minecraft.firework_star.black": "Juoda",
  "item.minecraft.firework_star.blue": "Mėlyna",
  "item.minecraft.firework_star.brown": "Ruda",
  "item.minecraft.firework_star.custom_color": "Pritaikyta spalva",
  "item.minecraft.firework_star.cyan": "Tamsiai žydra",
  "item.minecraft.firework_star.fade_to": "Išblėsta į:",
  "item.minecraft.firework_star.flicker": "Mirgėjimo efektas",
  "item.minecraft.firework_star.gray": "Pilka",
  "item.minecraft.firework_star.green": "Žalia",
  "item.minecraft.firework_star.light_blue": "Žydra",
  "item.minecraft.firework_star.light_gray": "Šviesiai pilka",
  "item.minecraft.firework_star.lime": "Šviesiai žalia",
  "item.minecraft.firework_star.magenta": "Šviesiai purpurinė spalva",
  "item.minecraft.firework_star.orange": "Oranžinė",
  "item.minecraft.firework_star.pink": "Rausva",
  "item.minecraft.firework_star.purple": "Purpurinė",
  "item.minecraft.firework_star.red": "Raudona",
  "item.minecraft.firework_star.shape": "Nežinoma forma",
  "item.minecraft.firework_star.shape.burst": "Plyšimas",
  "item.minecraft.firework_star.shape.creeper": "Kryperio forma",
  "item.minecraft.firework_star.shape.large_ball": "Didelis kamuolys",
  "item.minecraft.firework_star.shape.small_ball": "Mažas kamuolys",
  "item.minecraft.firework_star.shape.star": "Žvaigždės forma",
  "item.minecraft.firework_star.trail": "Nutįsimo efektas",
  "item.minecraft.firework_star.white": "Balta spalva",
  "item.minecraft.firework_star.yellow": "Geltona",
  "item.minecraft.fishing_rod": "Meškerė",
  "item.minecraft.flint": "Titnagas",
  "item.minecraft.flint_and_steel": "Titnagas ir geležis",
  "item.minecraft.flow_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Srauto šarvų puošmuo",
  "item.minecraft.flow_banner_pattern": "Vėliavos raštas",
  "item.minecraft.flow_banner_pattern.desc": "Spiralė",
  "item.minecraft.flow_banner_pattern.new": "Spiralės vėliavos raštas",
  "item.minecraft.flow_pottery_sherd": "Srauto keramikos šukė",
  "item.minecraft.flower_banner_pattern": "Vėliavos raštas",
  "item.minecraft.flower_banner_pattern.desc": "Gėlė",
  "item.minecraft.flower_banner_pattern.new": "Gėlės vėliavos raštas",
  "item.minecraft.flower_pot": "Vazonas",
  "item.minecraft.fox_spawn_egg": "Suformuotos lapės kiaušinis",
  "item.minecraft.friend_pottery_shard": "Draugo keramikos šukė",
  "item.minecraft.friend_pottery_sherd": "Draugo keramikos šukė",
  "item.minecraft.frog_spawn_egg": "Suformuotos varlės kiaušinis",
  "item.minecraft.furnace_minecart": "Vagonėlis su krosnimi",
  "item.minecraft.ghast_spawn_egg": "Suformuoto ghasto kiaušinis",
  "item.minecraft.ghast_tear": "Ghasto ašara",
  "item.minecraft.glass_bottle": "Stiklinis buteliukas",
  "item.minecraft.glistering_melon_slice": "Žvilganti arbūzo skiltelė",
  "item.minecraft.globe_banner_pattern": "Vėliavos raštas",
  "item.minecraft.globe_banner_pattern.desc": "Gaublys",
  "item.minecraft.globe_banner_pattern.new": "Gaublio vėliavos raštas",
  "item.minecraft.glow_berries": "Švytinčios uogos",
  "item.minecraft.glow_ink_sac": "Švytinčio rašalo pūslė",
  "item.minecraft.glow_item_frame": "Švytintis daikto rėmas",
  "item.minecraft.glow_squid_spawn_egg": "Suformuoto švytinčio kalmaro kiaušinis",
  "item.minecraft.glowstone_dust": "Šviesakmenio dulkės",
  "item.minecraft.goat_horn": "Ožkos ragas",
  "item.minecraft.goat_spawn_egg": "Suformuotos ožkos kiaušinis",
  "item.minecraft.gold_ingot": "Aukso liejinys",
  "item.minecraft.gold_nugget": "Aukso grynuolis",
  "item.minecraft.golden_apple": "Auksinis obuolys",
  "item.minecraft.golden_axe": "Auksinis kirvis",
  "item.minecraft.golden_boots": "Auksiniai batai",
  "item.minecraft.golden_carrot": "Auksinė morka",
  "item.minecraft.golden_chestplate": "Auksinis antkrūtinis",
  "item.minecraft.golden_helmet": "Auksinis šalmas",
  "item.minecraft.golden_hoe": "Auksinis kaplys",
  "item.minecraft.golden_horse_armor": "Auksiniai arklio šarvai",
  "item.minecraft.golden_leggings": "Auksinės kelnės",
  "item.minecraft.golden_nautilus_armor": "Auksiniai nautilo šarvai",
  "item.minecraft.golden_pickaxe": "Auksinis kirtiklis",
  "item.minecraft.golden_shovel": "Auksinis kastuvas",
  "item.minecraft.golden_spear": "Auksinė ietis",
  "item.minecraft.golden_sword": "Auksinis kardas",
  "item.minecraft.gray_bundle": "Pilkas ryšulys",
  "item.minecraft.gray_dye": "Pilki dažai",
  "item.minecraft.gray_harness": "Pilki pakinktai",
  "item.minecraft.green_bundle": "Žalias ryšulys",
  "item.minecraft.green_dye": "Žali dažai",
  "item.minecraft.green_harness": "Žali pakinktai",
  "item.minecraft.guardian_spawn_egg": "Suformuoto gelmių sargo kiaušinis",
  "item.minecraft.gunpowder": "Parakas",
  "item.minecraft.guster_banner_pattern": "Vėliavos raštas",
  "item.minecraft.guster_banner_pattern.desc": "Gūsis",
  "item.minecraft.guster_banner_pattern.new": "Gūsio vėliavos raštas",
  "item.minecraft.guster_pottery_sherd": "Gūsio keramikos šukė",
  "item.minecraft.happy_ghast_spawn_egg": "Suformuoto laimingo ghasto kiaušinis",
  "item.minecraft.harness": "Pakinktai",
  "item.minecraft.heart_of_the_sea": "Jūros širdis",
  "item.minecraft.heart_pottery_shard": "Širdies keramikos šukė",
  "item.minecraft.heart_pottery_sherd": "Širdies keramikos šukė",
  "item.minecraft.heartbreak_pottery_shard": "Širdgėlos keramikos šukė",
  "item.minecraft.heartbreak_pottery_sherd": "Širdgėlos keramikos šukė",
  "item.minecraft.hoglin_spawn_egg": "Suformuoto hoglino kiaušinis",
  "item.minecraft.honey_bottle": "Medaus buteliukas",
  "item.minecraft.honeycomb": "Korys",
  "item.minecraft.hopper_minecart": "Vagonėlis su piltuvu",
  "item.minecraft.horse_spawn_egg": "Suformuoto arklio kiaušinis",
  "item.minecraft.host_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.host_armor_trim_smithing_template.new": "Šeimininko šarvų puošmuo",
  "item.minecraft.howl_pottery_shard": "Vilko keramikos šukė",
  "item.minecraft.howl_pottery_sherd": "Vilko keramikos šukė",
  "item.minecraft.husk_spawn_egg": "Suformuoto sudžiūvėlio kiaušinis",
  "item.minecraft.ink_sac": "Rašalo pūslė",
  "item.minecraft.iron_axe": "Geležinis kirvis",
  "item.minecraft.iron_boots": "Geležiniai batai",
  "item.minecraft.iron_chestplate": "Geležinis antkrūtinis",
  "item.minecraft.iron_golem_spawn_egg": "Suformuoto geležinio golemo kiaušinis",
  "item.minecraft.iron_helmet": "Geležinis šalmas",
  "item.minecraft.iron_hoe": "Geležinis kaplys",
  "item.minecraft.iron_horse_armor": "Geležiniai arklio šarvai",
  "item.minecraft.iron_ingot": "Geležies liejinys",
  "item.minecraft.iron_leggings": "Geležinės kelnės",
  "item.minecraft.iron_nautilus_armor": "Geležiniai nautilo šarvai",
  "item.minecraft.iron_nugget": "Geležies grynuolis",
  "item.minecraft.iron_pickaxe": "Geležinis kirtiklis",
  "item.minecraft.iron_shovel": "Geležinis kastuvas",
  "item.minecraft.iron_spear": "Geležinė ietis",
  "item.minecraft.iron_sword": "Geležinis kardas",
  "item.minecraft.item_frame": "Rėmelis",
  "item.minecraft.jungle_boat": "Džiunglių medžio valtis",
  "item.minecraft.jungle_chest_boat": "Džiunglių medžio valtis su skrynia",
  "item.minecraft.knowledge_book": "Žinių knyga",
  "item.minecraft.lapis_lazuli": "Lazuritas",
  "item.minecraft.lava_bucket": "Lavos kibiras",
  "item.minecraft.lead": "Pavadis",
  "item.minecraft.leather": "Oda",
  "item.minecraft.leather_boots": "Odiniai batai",
  "item.minecraft.leather_chestplate": "Odinė tunika",
  "item.minecraft.leather_helmet": "Odinė kepurė",
  "item.minecraft.leather_horse_armor": "Odiniai arklio šarvai",
  "item.minecraft.leather_leggings": "Odinės kelnės",
  "item.minecraft.light_blue_bundle": "Žydras ryšulys",
  "item.minecraft.light_blue_dye": "Žydri dažai",
  "item.minecraft.light_blue_harness": "Šviesiai mėlyni pakinktai",
  "item.minecraft.light_gray_bundle": "Šviesiai pilkas ryšulys",
  "item.minecraft.light_gray_dye": "Šviesiai pilki dažai",
  "item.minecraft.light_gray_harness": "Šviesiai pilki pakinktai",
  "item.minecraft.lime_bundle": "Šviesiai žalias ryšulys",
  "item.minecraft.lime_dye": "Šviesiai žali dažai",
  "item.minecraft.lime_harness": "Šviesiai žali pakinktai",
  "item.minecraft.lingering_potion": "Garuojantis eliksyras",
  "item.minecraft.lingering_potion.effect.awkward": "Garuojantis keistas eliksyras",
  "item.minecraft.lingering_potion.effect.empty": "Garuojantis nepagaminamas eliksyras",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Garuojantis atsparumo ugniai eliksyras",
  "item.minecraft.lingering_potion.effect.harming": "Garuojantis žalos eliksyras",
  "item.minecraft.lingering_potion.effect.healing": "Garuojantis gydymo eliksyras",
  "item.minecraft.lingering_potion.effect.infested": "Garuojantis užkrėtimo eliksyras",
  "item.minecraft.lingering_potion.effect.invisibility": "Garuojantis nematomumo eliksyras",
  "item.minecraft.lingering_potion.effect.leaping": "Garuojantis šoklumo eliksyras",
  "item.minecraft.lingering_potion.effect.levitation": "Garuojantis sklandymo eliksyras",
  "item.minecraft.lingering_potion.effect.luck": "Garuojantis sėkmės eliksyras",
  "item.minecraft.lingering_potion.effect.mundane": "Garuojantis nuobodus eliksyras",
  "item.minecraft.lingering_potion.effect.night_vision": "Garuojantis naktinio matymo eliksyras",
  "item.minecraft.lingering_potion.effect.oozing": "Garuojantis išsiveržimo eliksyras",
  "item.minecraft.lingering_potion.effect.poison": "Garuojantis nuodų eliksyrų",
  "item.minecraft.lingering_potion.effect.regeneration": "Garuojantis atgijimo eliksyras",
  "item.minecraft.lingering_potion.effect.slow_falling": "Garuojantis lėto kritimo eliksyras",
  "item.minecraft.lingering_potion.effect.slowness": "Garuojantis lėtumo eliksyras",
  "item.minecraft.lingering_potion.effect.strength": "Garuojantis jėgos eliksyras",
  "item.minecraft.lingering_potion.effect.swiftness": "Garuojantis greičio eliksyras",
  "item.minecraft.lingering_potion.effect.thick": "Garuojantis tirštas eliksyras",
  "item.minecraft.lingering_potion.effect.turtle_master": "Garuojantis vėžlių valdovo eliksyras",
  "item.minecraft.lingering_potion.effect.water": "Garuojantis vandens buteliukas",
  "item.minecraft.lingering_potion.effect.water_breathing": "Garuojantis kvėpavimo vandeniu eliksyras",
  "item.minecraft.lingering_potion.effect.weakness": "Garuojantis silpnumo eliksyras",
  "item.minecraft.lingering_potion.effect.weaving": "Garuojantis apipynimo eliksyras",
  "item.minecraft.lingering_potion.effect.wind_charged": "Garuojantis vėjo įkrovimo eliksyras",
  "item.minecraft.llama_spawn_egg": "Suformuotos lamos kiaušinis",
  "item.minecraft.lodestone_compass": "Magnetito kompasas",
  "item.minecraft.mace": "Vėzdas",
  "item.minecraft.magenta_bundle": "Purpurinis ryšulys",
  "item.minecraft.magenta_dye": "Šviesiai purpuriniai dažai",
  "item.minecraft.magenta_harness": "Purpuriniai pakinktai",
  "item.minecraft.magma_cream": "Magmos kremas",
  "item.minecraft.magma_cube_spawn_egg": "Suformuoto magmos kubo kiaušinis",
  "item.minecraft.mangrove_boat": "Mangrovės valtis",
  "item.minecraft.mangrove_chest_boat": "Mangrovės valtis su skrynia",
  "item.minecraft.map": "Tuščias žemėlapis",
  "item.minecraft.melon_seeds": "Arbūzų sėklos",
  "item.minecraft.melon_slice": "Arbūzo skiltelė",
  "item.minecraft.milk_bucket": "Pieno kibiras",
  "item.minecraft.minecart": "Vagonėlis",
  "item.minecraft.miner_pottery_shard": "Kasinėtojo keramikos šukė",
  "item.minecraft.miner_pottery_sherd": "Kasinėtojo keramikos šukė",
  "item.minecraft.mojang_banner_pattern": "Vėliavos raštas",
  "item.minecraft.mojang_banner_pattern.desc": "Dalykas",
  "item.minecraft.mojang_banner_pattern.new": "Dalyko vėliavos raštas",
  "item.minecraft.mooshroom_spawn_egg": "Suformuoto mooshroom kiaušinis",
  "item.minecraft.mourner_pottery_shard": "Raudotojo keramikos šukė",
  "item.minecraft.mourner_pottery_sherd": "Raudotojo keramikos šukė",
  "item.minecraft.mule_spawn_egg": "Suformuoto mulo kiaušinis",
  "item.minecraft.mushroom_stew": "Grybų troškinys",
  "item.minecraft.music_disc_11": "Muzikos diskas",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muzikos diskas",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muzikos diskas",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muzikos diskas",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muzikos diskas",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muzikos diskas",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muzikos diskas",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Muzikos diskas",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Muzikos diskas",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Muzikos diskas",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muzikos diskas",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muzikos diskas",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muzikos diskas",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Muzikos diskas",
  "item.minecraft.music_disc_pigstep.desc": "Lena Rainia - Pigstep",
  "item.minecraft.music_disc_precipice": "Muzikos diskas",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muzikos diskas",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muzikos diskas",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muzikos diskas",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Muzikos diskas",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muzikos diskas",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muzikos diskas",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Žalia aviena",
  "item.minecraft.name_tag": "Vardo žymeklis",
  "item.minecraft.nautilus_shell": "Nautilo moliusko kiautas",
  "item.minecraft.nautilus_spawn_egg": "Suformuoto nautilo kiaušinis",
  "item.minecraft.nether_brick": "Netherio plytos",
  "item.minecraft.nether_star": "Netherio žvaigždė",
  "item.minecraft.nether_wart": "Netherio gumbas",
  "item.minecraft.netherite_axe": "Netheritinis kirvis",
  "item.minecraft.netherite_boots": "Netheritiniai batai",
  "item.minecraft.netherite_chestplate": "Netheritinis antkrūtinis",
  "item.minecraft.netherite_helmet": "Netheritinis šalmas",
  "item.minecraft.netherite_hoe": "Netheritinis kaplys",
  "item.minecraft.netherite_horse_armor": "Netheritiniai arklio šarvai",
  "item.minecraft.netherite_ingot": "Netherito liejinys",
  "item.minecraft.netherite_leggings": "Netheritinės kelnės",
  "item.minecraft.netherite_nautilus_armor": "Netheritiniai nautilo šarvai",
  "item.minecraft.netherite_pickaxe": "Netheritinis kirtiklis",
  "item.minecraft.netherite_scrap": "Netherito atraiža",
  "item.minecraft.netherite_shovel": "Netheritinis kastuvas",
  "item.minecraft.netherite_spear": "Netheritinė ietis",
  "item.minecraft.netherite_sword": "Netheritinis kardas",
  "item.minecraft.netherite_upgrade_smithing_template": "Kalvio šablonas",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritinis patobulinimas",
  "item.minecraft.oak_boat": "Ąžuolo valtis",
  "item.minecraft.oak_chest_boat": "Ąžuolo valtis su skrynia",
  "item.minecraft.ocelot_spawn_egg": "Suformuoto oceloto kiaušinis",
  "item.minecraft.ominous_bottle": "Grėsmingas buteliukas",
  "item.minecraft.ominous_trial_key": "Grėsmingo išbandymo raktas",
  "item.minecraft.orange_bundle": "Oranžinis ryšulys",
  "item.minecraft.orange_dye": "Oranžiniai dažai",
  "item.minecraft.orange_harness": "Oranžiniai pakinktai",
  "item.minecraft.painting": "Paveikslas",
  "item.minecraft.pale_oak_boat": "Blyškiojo ąžuolo valtis",
  "item.minecraft.pale_oak_chest_boat": "Blyškiojo ąžuolo valtis su skrynia",
  "item.minecraft.panda_spawn_egg": "Suformuotos pandos kiaušinis",
  "item.minecraft.paper": "Popierius",
  "item.minecraft.parched_spawn_egg": "Suformuoto trošklio kiaušinis",
  "item.minecraft.parrot_spawn_egg": "Suformuotos papūgos kiaušinis",
  "item.minecraft.phantom_membrane": "Fantomo membrana",
  "item.minecraft.phantom_spawn_egg": "Suformuoto fantomo kiaušinis",
  "item.minecraft.pig_spawn_egg": "Suformuotos kiaulės kiaušinis",
  "item.minecraft.piglin_banner_pattern": "Vėliavos raštas",
  "item.minecraft.piglin_banner_pattern.desc": "Šnipas",
  "item.minecraft.piglin_banner_pattern.new": "Šnipo vėliavos raštas",
  "item.minecraft.piglin_brute_spawn_egg": "Suformuoto aršiojo piglino kiaušinis",
  "item.minecraft.piglin_spawn_egg": "Suformuoto piglino kiaušinis",
  "item.minecraft.pillager_spawn_egg": "Suformuoto plėšiko kiaušinis",
  "item.minecraft.pink_bundle": "Rausvas ryšulys",
  "item.minecraft.pink_dye": "Rausvi dažai",
  "item.minecraft.pink_harness": "Rausvi pakinktai",
  "item.minecraft.pitcher_plant": "Ąsotenis",
  "item.minecraft.pitcher_pod": "Ąsotenio ankštis",
  "item.minecraft.plenty_pottery_shard": "Pertekliaus keramikos šukė",
  "item.minecraft.plenty_pottery_sherd": "Pertekliaus keramikos šukė",
  "item.minecraft.poisonous_potato": "Nuodinga bulvė",
  "item.minecraft.polar_bear_spawn_egg": "Suformuoto baltojo lokio kiaušinis",
  "item.minecraft.popped_chorus_fruit": "Spragintas koruso vaisius",
  "item.minecraft.porkchop": "Žalia kiauliena",
  "item.minecraft.potato": "Bulvė",
  "item.minecraft.potion": "Eliksyras",
  "item.minecraft.potion.effect.awkward": "Keistas eliksyras",
  "item.minecraft.potion.effect.empty": "Nepagaminamas eliksyras",
  "item.minecraft.potion.effect.fire_resistance": "Atsparumo ugniai eliksyras",
  "item.minecraft.potion.effect.harming": "Žalos eliksyras",
  "item.minecraft.potion.effect.healing": "Gydymo eliksyras",
  "item.minecraft.potion.effect.infested": "Užkrėtimo eliksyras",
  "item.minecraft.potion.effect.invisibility": "Nematomumo eliksyras",
  "item.minecraft.potion.effect.leaping": "Šoklumo eliksyras",
  "item.minecraft.potion.effect.levitation": "Levitacijos eliksyras",
  "item.minecraft.potion.effect.luck": "Sėkmės eliksyras",
  "item.minecraft.potion.effect.mundane": "Paprastas eliksyras",
  "item.minecraft.potion.effect.night_vision": "Naktinio matymo eliksyras",
  "item.minecraft.potion.effect.oozing": "Išsiveržimo eliksyras",
  "item.minecraft.potion.effect.poison": "Nuodų eliksyras",
  "item.minecraft.potion.effect.regeneration": "Atgijimo eliksyras",
  "item.minecraft.potion.effect.slow_falling": "Lėto kritimo eliksyras",
  "item.minecraft.potion.effect.slowness": "Lėtumo eliksyras",
  "item.minecraft.potion.effect.strength": "Jėgos eliksyras",
  "item.minecraft.potion.effect.swiftness": "Greičio eliksyras",
  "item.minecraft.potion.effect.thick": "Tirštas eliksyras",
  "item.minecraft.potion.effect.turtle_master": "Vėžlių valdovo eliksyras",
  "item.minecraft.potion.effect.water": "Vandens buteliukas",
  "item.minecraft.potion.effect.water_breathing": "Kvėpavimo vandeniu eliksyras",
  "item.minecraft.potion.effect.weakness": "Silpnumo eliksyras",
  "item.minecraft.potion.effect.weaving": "Apipynimo eliksyras",
  "item.minecraft.potion.effect.wind_charged": "Vėjo įkrovimo eliksyras",
  "item.minecraft.pottery_shard_archer": "Lankininko keramikos šukė",
  "item.minecraft.pottery_shard_arms_up": "Čempiono keramikos šukė",
  "item.minecraft.pottery_shard_prize": "Prizo keramikos šukė",
  "item.minecraft.pottery_shard_skull": "Kaukolės keramikos šukė",
  "item.minecraft.powder_snow_bucket": "Puraus sniego kibiras",
  "item.minecraft.prismarine_crystals": "Prizmarino kristalai",
  "item.minecraft.prismarine_shard": "Prizmarino skeveldra",
  "item.minecraft.prize_pottery_shard": "Prizo keramikos šukė",
  "item.minecraft.prize_pottery_sherd": "Prizo keramikos šukė",
  "item.minecraft.pufferfish": "Pūsliažuvė",
  "item.minecraft.pufferfish_bucket": "Pūsliažuvė kibire",
  "item.minecraft.pufferfish_spawn_egg": "Suformuotos pūsliažuvės kiaušinis",
  "item.minecraft.pumpkin_pie": "Moliūgų pyragas",
  "item.minecraft.pumpkin_seeds": "Moliūgų sėklos",
  "item.minecraft.purple_bundle": "Violetinis ryšulys",
  "item.minecraft.purple_dye": "Purpuriniai dažai",
  "item.minecraft.purple_harness": "Violetiniai pakinktai",
  "item.minecraft.quartz": "Netherio kvarcas",
  "item.minecraft.rabbit": "Žalias triušis",
  "item.minecraft.rabbit_foot": "Triušio pėda",
  "item.minecraft.rabbit_hide": "Triušio kailis",
  "item.minecraft.rabbit_spawn_egg": "Suformuoto triušio kiaušinis",
  "item.minecraft.rabbit_stew": "Triušienos troškinys",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Pakėlėjo šarvų puošmuo",
  "item.minecraft.ravager_spawn_egg": "Suformuoto siaubūno kiaušinis",
  "item.minecraft.raw_copper": "Neapdorotas varis",
  "item.minecraft.raw_gold": "Neapdorotas auksas",
  "item.minecraft.raw_iron": "Neapdorota geležis",
  "item.minecraft.recovery_compass": "Susigrąžinimo kompasas",
  "item.minecraft.red_bundle": "Raudonas ryšulys",
  "item.minecraft.red_dye": "Raudoni dažai",
  "item.minecraft.red_harness": "Raudoni pakinktai",
  "item.minecraft.redstone": "Redstono dulkės",
  "item.minecraft.resin_brick": "Sakų plyta",
  "item.minecraft.resin_clump": "Sakų gumulas",
  "item.minecraft.rib_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Kaulo šarvų puošmuo",
  "item.minecraft.rotten_flesh": "Supuvusi mėsa",
  "item.minecraft.saddle": "Balnas",
  "item.minecraft.salmon": "Žalia lašiša",
  "item.minecraft.salmon_bucket": "Lašiša kibire",
  "item.minecraft.salmon_spawn_egg": "Suformuotos lašišos kiaušinis",
  "item.minecraft.scrape_pottery_sherd": "Nugrandymo keramikos šukė",
  "item.minecraft.scute": "Skydelis",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sargybinio šarvų puošmuo",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Formuotojo šarvų puošmuo",
  "item.minecraft.sheaf_pottery_shard": "Pluošto keramikos šukė",
  "item.minecraft.sheaf_pottery_sherd": "Pluošto keramikos šukė",
  "item.minecraft.shears": "Žirklės",
  "item.minecraft.sheep_spawn_egg": "Suformuotos avies kiaušinis",
  "item.minecraft.shelter_pottery_shard": "Pastogės keramikos šukė",
  "item.minecraft.shelter_pottery_sherd": "Pastogės keramikos šukė",
  "item.minecraft.shield": "Skydas",
  "item.minecraft.shield.black": "Juodas skydas",
  "item.minecraft.shield.blue": "Mėlynas skydas",
  "item.minecraft.shield.brown": "Rudas skydas",
  "item.minecraft.shield.cyan": "Tamsiai žydras skydas",
  "item.minecraft.shield.gray": "Pilkas skydas",
  "item.minecraft.shield.green": "Žalias skydas",
  "item.minecraft.shield.light_blue": "Žydra skydas",
  "item.minecraft.shield.light_gray": "Šviesiai pilkas skydas",
  "item.minecraft.shield.lime": "Šviesiai žalias skydas",
  "item.minecraft.shield.magenta": "Šviesiai purpurinis skydas",
  "item.minecraft.shield.orange": "Oranžinis skydas",
  "item.minecraft.shield.pink": "Rausvas skydas",
  "item.minecraft.shield.purple": "Purpurinis skydas",
  "item.minecraft.shield.red": "Raudonas skydas",
  "item.minecraft.shield.white": "Baltas skydas",
  "item.minecraft.shield.yellow": "Geltonas skydas",
  "item.minecraft.shulker_shell": "Šulkerio kiautas",
  "item.minecraft.shulker_spawn_egg": "Suformuoto šulkerio kiaušinis",
  "item.minecraft.sign": "Ženklas",
  "item.minecraft.silence_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Tylos šarvų puošmuo",
  "item.minecraft.silverfish_spawn_egg": "Suformuoto žvyninuko kiaušinis",
  "item.minecraft.skeleton_horse_spawn_egg": "Suformuoto skeleto arklio kiaušinis",
  "item.minecraft.skeleton_spawn_egg": "Suformuoto skeleto kiaušinis",
  "item.minecraft.skull_banner_pattern": "Vėliavos raštas",
  "item.minecraft.skull_banner_pattern.desc": "Kaukolė",
  "item.minecraft.skull_banner_pattern.new": "Kaukolės vėliavos raštas",
  "item.minecraft.skull_pottery_shard": "Kaukolės keramikos šukė",
  "item.minecraft.skull_pottery_sherd": "Kaukolės keramikos šukė",
  "item.minecraft.slime_ball": "Gleivių kamuolėlis",
  "item.minecraft.slime_spawn_egg": "Suformuoto gleiviaus kiaušinis",
  "item.minecraft.smithing_template": "Kalvio šablonas",
  "item.minecraft.smithing_template.applies_to": "Tai prisitaiko:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Įdėkite liejinį abra kristalą",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Šarvai",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Įdėkite šarvus",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Liejiniai ir kristalai",
  "item.minecraft.smithing_template.ingredients": "Ingredientai:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Įdėkite Netherito liejinį",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Deimantinė Įranga",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Įdėkite deimantinius šarvus, ginklą arba įrankį",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherito liejinys",
  "item.minecraft.smithing_template.upgrade": "Patobulinimas: ",
  "item.minecraft.sniffer_spawn_egg": "Suformuoto šniukštinėtojo kiaušinis",
  "item.minecraft.snort_pottery_shard": "Šnipo keramikos šukė",
  "item.minecraft.snort_pottery_sherd": "Šniokščianti keramikos šukė",
  "item.minecraft.snout_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Šnipo šarvų puošmuo",
  "item.minecraft.snow_golem_spawn_egg": "Suformuoto sniego golemo kiaušinis",
  "item.minecraft.snowball": "Sniego gniūžtė",
  "item.minecraft.spectral_arrow": "Auros strėlė",
  "item.minecraft.spider_eye": "Voro akis",
  "item.minecraft.spider_spawn_egg": "Suformuoto voro kiaušinis",
  "item.minecraft.spire_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Smaigalio šarvų puošmuo",
  "item.minecraft.splash_potion": "Mėtomas eliksyras",
  "item.minecraft.splash_potion.effect.awkward": "Mėtomas keistas eliksyras",
  "item.minecraft.splash_potion.effect.empty": "Mėtomas nepagaminamas eliksyras",
  "item.minecraft.splash_potion.effect.fire_resistance": "Mėtomas atsparumo ugniai eliksyras",
  "item.minecraft.splash_potion.effect.harming": "Mėtomas žalos eliksyras",
  "item.minecraft.splash_potion.effect.healing": "Mėtomas gydymo eliksyras",
  "item.minecraft.splash_potion.effect.infested": "Mėtomas užkrėtimo eliksyras",
  "item.minecraft.splash_potion.effect.invisibility": "Mėtomas nematomumo eliksyras",
  "item.minecraft.splash_potion.effect.leaping": "Mėtomas šoklumo eliksyras",
  "item.minecraft.splash_potion.effect.levitation": "Mėtomas levitacijos eliksyras",
  "item.minecraft.splash_potion.effect.luck": "Mėtomas sėkmės eliksyras",
  "item.minecraft.splash_potion.effect.mundane": "Mėtomas nuobodus eliksyras",
  "item.minecraft.splash_potion.effect.night_vision": "Mėtomas naktinio matymo eliksyras",
  "item.minecraft.splash_potion.effect.oozing": "Mėtomas išsiveržimo eliksyras",
  "item.minecraft.splash_potion.effect.poison": "Mėtomas nuodų eliksyras",
  "item.minecraft.splash_potion.effect.regeneration": "Mėtomas atgijimo eliksyras",
  "item.minecraft.splash_potion.effect.slow_falling": "Mėtomas lėto kritimo eliksyras",
  "item.minecraft.splash_potion.effect.slowness": "Mėtomas lėtumo eliksyras",
  "item.minecraft.splash_potion.effect.strength": "Mėtomas jėgos eliksyras",
  "item.minecraft.splash_potion.effect.swiftness": "Mėtomas greičio eliksyras",
  "item.minecraft.splash_potion.effect.thick": "Mėtomas tirštas eliksyras",
  "item.minecraft.splash_potion.effect.turtle_master": "Mėtomas vėžlių valdovo eliksyras",
  "item.minecraft.splash_potion.effect.water": "Mėtomas vandens buteliukas",
  "item.minecraft.splash_potion.effect.water_breathing": "Mėtomas kvėpavimo vandeniu eliksyras",
  "item.minecraft.splash_potion.effect.weakness": "Mėtomas silpnumo eliksyras",
  "item.minecraft.splash_potion.effect.weaving": "Mėtomas apipynimo eliksyras",
  "item.minecraft.splash_potion.effect.wind_charged": "Mėtomas vėjo įkrovimo eliksyras",
  "item.minecraft.spruce_boat": "Eglės valtis",
  "item.minecraft.spruce_chest_boat": "Eglės valtis su skrynia",
  "item.minecraft.spyglass": "Žiūronas",
  "item.minecraft.squid_spawn_egg": "Suformuoto kalmaro kiaušinis",
  "item.minecraft.stick": "Pagaliukas",
  "item.minecraft.stone_axe": "Akmeninis kirvis",
  "item.minecraft.stone_hoe": "Akmeninis kaplys",
  "item.minecraft.stone_pickaxe": "Akmeninis kirtiklis",
  "item.minecraft.stone_shovel": "Akmeninis kastuvas",
  "item.minecraft.stone_spear": "Akmeninė ietis",
  "item.minecraft.stone_sword": "Akmeninis kardas",
  "item.minecraft.stray_spawn_egg": "Suformuoto klajūno kiaušinis",
  "item.minecraft.strider_spawn_egg": "Suformuoto ilgažingsnio kiaušinis",
  "item.minecraft.string": "Siūlas",
  "item.minecraft.sugar": "Cukrus",
  "item.minecraft.suspicious_stew": "Įtartinas troškinys",
  "item.minecraft.sweet_berries": "Saldžiosios uogos",
  "item.minecraft.tadpole_bucket": "Buožgalvis kibire",
  "item.minecraft.tadpole_spawn_egg": "Suformuoto buožgalvio kiaušinis",
  "item.minecraft.tide_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Bangos šarvų puošmuo",
  "item.minecraft.tipped_arrow": "Patepta strėlė",
  "item.minecraft.tipped_arrow.effect.awkward": "Patepta strėlė",
  "item.minecraft.tipped_arrow.effect.empty": "Nepagaminama patepta strėlė",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Atsparumo ugniai strėlė",
  "item.minecraft.tipped_arrow.effect.harming": "Žalos strėlė",
  "item.minecraft.tipped_arrow.effect.healing": "Gydymo strėlė",
  "item.minecraft.tipped_arrow.effect.infested": "Užkrėtimo strėlė",
  "item.minecraft.tipped_arrow.effect.invisibility": "Nematomumo strėlė",
  "item.minecraft.tipped_arrow.effect.leaping": "Šoklumo strėlė",
  "item.minecraft.tipped_arrow.effect.levitation": "Sklandymo strėlė",
  "item.minecraft.tipped_arrow.effect.luck": "Sėkmės strėlė",
  "item.minecraft.tipped_arrow.effect.mundane": "Patepta strėlė",
  "item.minecraft.tipped_arrow.effect.night_vision": "Naktinio matymo strėlė",
  "item.minecraft.tipped_arrow.effect.oozing": "Išsiveržimo strėlė",
  "item.minecraft.tipped_arrow.effect.poison": "Užnuodyta strėlė",
  "item.minecraft.tipped_arrow.effect.regeneration": "Atgijimo strėlė",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Lėto kritimo strėlė",
  "item.minecraft.tipped_arrow.effect.slowness": "Lėtumo strėlė",
  "item.minecraft.tipped_arrow.effect.strength": "Jėgos strėlė",
  "item.minecraft.tipped_arrow.effect.swiftness": "Greičio strėlė",
  "item.minecraft.tipped_arrow.effect.thick": "Patepta strėlė",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Vėžlių valdovo strėlė",
  "item.minecraft.tipped_arrow.effect.water": "Vandens purslų strėlė",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Kvėpavimo vandeniu strėlė",
  "item.minecraft.tipped_arrow.effect.weakness": "Silpnumo strėlė",
  "item.minecraft.tipped_arrow.effect.weaving": "Apipynimo strėlė",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vėjo įkrovimo strėlė",
  "item.minecraft.tnt_minecart": "Vagonėlis su TNT",
  "item.minecraft.torchflower_seeds": "Knipofijos sėklos",
  "item.minecraft.totem_of_undying": "Nemirtingumo totemas",
  "item.minecraft.trader_llama_spawn_egg": "Suformuotos pirklio lamos kiaušinis",
  "item.minecraft.trial_key": "Išbandymo raktas",
  "item.minecraft.trident": "Trišakis",
  "item.minecraft.tropical_fish": "Tropinė žuvis",
  "item.minecraft.tropical_fish_bucket": "Tropinė žuvis kibire",
  "item.minecraft.tropical_fish_spawn_egg": "Suformuotos tropinės žuvies kiaušinis",
  "item.minecraft.turtle_helmet": "Vėžlio kiautas",
  "item.minecraft.turtle_scute": "Vėžlio skydelis",
  "item.minecraft.turtle_spawn_egg": "Suformuoto vėžlio kiaušinis",
  "item.minecraft.vex_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vėlės šarvų puošmuo",
  "item.minecraft.vex_spawn_egg": "Suformuotos vėlės kiaušinis",
  "item.minecraft.villager_spawn_egg": "Suformuoto kaimiečio kiaušinis",
  "item.minecraft.vindicator_spawn_egg": "Suformuoto vindikatoriaus kiaušinis",
  "item.minecraft.wandering_trader_spawn_egg": "Suformuoto klajojančio pirklio kiaušinis",
  "item.minecraft.ward_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Komendanto šarvų puošmuo",
  "item.minecraft.warden_spawn_egg": "Suformuoto komendanto kiaušinis",
  "item.minecraft.warped_fungus_on_a_stick": "Klaikusis grybas ant pagaliuko",
  "item.minecraft.water_bucket": "Vandens kibiras",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Keliauninko šarvų puošmuo",
  "item.minecraft.wheat": "Kviečiai",
  "item.minecraft.wheat_seeds": "Kviečių sėklos",
  "item.minecraft.white_bundle": "Baltas ryšulys",
  "item.minecraft.white_dye": "Balti dažai",
  "item.minecraft.white_harness": "Balti pakinktai",
  "item.minecraft.wild_armor_trim_smithing_template": "Kalvio šablonas",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Laukinių šarvų puošmuo",
  "item.minecraft.wind_charge": "Vėjo krūvis",
  "item.minecraft.witch_spawn_egg": "Suformuotos raganos kiaušinis",
  "item.minecraft.wither_skeleton_spawn_egg": "Suformuoto wither skeleto kiaušinis",
  "item.minecraft.wither_spawn_egg": "Suformuoto witherio kiaušinis",
  "item.minecraft.wolf_armor": "Vilko šarvai",
  "item.minecraft.wolf_spawn_egg": "Suformuoto vilko kiaušinis",
  "item.minecraft.wooden_axe": "Medinis kirvis",
  "item.minecraft.wooden_hoe": "Medinis kaplys",
  "item.minecraft.wooden_pickaxe": "Medinis kirtiklis",
  "item.minecraft.wooden_shovel": "Medinis kastuvas",
  "item.minecraft.wooden_spear": "Medinė ietis",
  "item.minecraft.wooden_sword": "Medinis kardas",
  "item.minecraft.writable_book": "Knyga ir plunksna",
  "item.minecraft.written_book": "Prirašyta knyga",
  "item.minecraft.yellow_bundle": "Geltonas ryšulys",
  "item.minecraft.yellow_dye": "Geltoni dažai",
  "item.minecraft.yellow_harness": "Geltoni pakinktai",
  "item.minecraft.zoglin_spawn_egg": "Suformuoto zoglino kiaušinis",
  "item.minecraft.zombie_horse_spawn_egg": "Suformuoto zombio arklio kiaušinis",
  "item.minecraft.zombie_nautilus_spawn_egg": "Suformuoto zombio nautilo kiaušinis",
  "item.minecraft.zombie_spawn_egg": "Suformuoto zombio kiaušinis",
  "item.minecraft.zombie_villager_spawn_egg": "Suformuoto zombio kaimiečio kiaušinis",
  "item.minecraft.zombified_piglin_spawn_egg": "Suformuoto suzombinto piglino kiaušinis"
}
export const lt_lt = items; 
